<template>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Achieve</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">View Mock Portfolio</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Test your investment ideas safely with the Mock Portfolio. View Mock Portfolio by country.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view
                            functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Future enhancement coming soon, will provide personalized tracking functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="grid">
                        <div class="col-12 md:col-3">
                            <div class="card p-fluid">

                                <table class="w-full" :style="{ borderCollapse: 'collapse', tableLayout: 'auto' }">
                                    <thead>
                                    <tr>
                                        <th
                                            class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Investment
                                        </th>
                                        <th
                                            class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">
                                            Annual Income
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Stocks
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            {{ formatAmount(this.totalIncomeStocksProjected) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Funds
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            {{ formatAmount(this.totalIncomeFundsProjected) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Businesses
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            {{ formatAmount(this.totalIncomeBusinessesProjected) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            <span class="font-semibold">TOTAL</span>
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                                <span class="font-semibold">{{
                                                        formatAmount(this.totalIncomeStocksProjected +
                                                            this.totalIncomeFundsProjected +
                                                            this.totalIncomeBusinessesProjected)
                                                    }}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            &nbsp;
                                        </td>
                                        <td class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            &nbsp;
                                        </td>
                                    </tr>

                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            <span class="font-semibold">Portfolio Yield</span>
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                                <span class="font-semibold">{{
                                                        formatAmount(((this.totalIncomeStocksProjected +
                                                            this.totalIncomeFundsProjected) / this.totalAmountInvestedProjected) * 100.0)
                                                    }}%</span>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div style="height: 10px;"></div>

                    <DataTable :value="trackData" :paginator="true" class="p-datatable-gridlines" :rows="100"
                               dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true"
                               :reorderableColumns="true" v-model:filters="filters" filterDisplay="menu"
                               :loading="loading"
                               :filters="filters" responsiveLayout="scroll" :globalFilterFields="['name', 'code']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-2 p-2">
                                        <Dropdown v-model="selectedCountry" :options="countries" optionLabel="name"
                                                  optionValue="code" placeholder="Select a Country"
                                                  @change="onCountryChange"/>
                                    </div>

                                    <div class="col-12 lg:col-8 p-2">
                                        <MultiSelect v-model="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header" @change="onToggleColumns" display="chip"
                                                     placeholder="Select Columns" :filter="true"
                                                     filterPlaceholder="Search columns..."
                                                     :virtualScrollerOptions="{ itemSize: 40 }"/>
                                    </div>

                                    <div class="col-12 lg:col-2 p-2">
                                        <Dropdown v-model="selectedFormat" :options="formats" optionLabel="name"
                                                  optionValue="code" placeholder="Select a Format"
                                                  @change="onFormatChange"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-2 p-2">
                                        <Dropdown v-model="selectedCustomFilter" :options="customFiltersActive"
                                                  optionLabel="name" optionValue="id"
                                                  placeholder="Select a Custom Filter"
                                                  @change="onCustomFilterChange"/>
                                    </div>

                                    <div class="col-12 lg:col-5 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>

                                    <div class="col-12 lg:col-5 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Name or Code" style="width: 100%"/>
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>
                            No track data found.
                        </template>

                        <template #loading>
                            Loading track data. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="submitted"
                                        @click="callUpdateTrackData(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="submitted"
                                        @click="callDeleteTrackData(data)"/>
                            </template>
                        </Column>


                        <Column v-for="column in selectedColumns" :key="column.field" :field="column.field"
                                :sortable="column.sortable" :style="column.style" :frozen="column.frozen || false">

                            <template #header>
                                <span>
                                    {{ column.header }}
                                </span>
                            </template>

                            <template #body="{ data }">

                                <span v-if="(column.field === 'code') && (data.type === 'S')">
                                    <a href="javascript:void(0)" @click="onCompanyCodeClick(data)">
                                        {{ data[column.field] }}
                                    </a>
                                </span>

                                <span v-else-if="(column.field === 'code') && (data.type != 'S')">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else-if="column.field === 'type'">
                                    <span v-if="data[column.field] === 'I'" :class="'status-badge status-' + data.type">
                                        Businesses</span>
                                    <span v-if="data[column.field] === 'S'" :class="'status-badge status-' + data.type">
                                        Stocks</span>
                                    <span v-if="data[column.field] === 'F'" :class="'status-badge status-' + data.type">
                                        Funds</span>
                                    <span v-if="data[column.field] === 'E'" :class="'status-badge status-' + data.type">
                                        ETFS</span>
                                </span>

                                <span v-else-if="column.field === 'country'">
                                    <span
                                        :class="'mr-2 flag flag-' + data[column.field].toLowerCase()"
                                        style="width: 18px; height: 12px"/>
                                </span>

                                <span v-else-if="column.field === 'sharePriceId123'">
                                    {{ formatAmount(data[column.field]) }}
                                </span>

                                <span v-else-if="column.field === 'currentDividendYieldId050'">
                                    {{ formatAmount(data[column.field]) }}%
                                </span>

                                <span v-else-if="((column.field === 'siCriteriaYear20Id128') ||
                                    (column.field === 'siCriteriaYear15Id127') ||
                                    (column.field === 'siCriteriaYear10Id126') ||
                                    (column.field === 'siCriteriaYear5Id125'))">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else-if="column.field === 'companyNameId046'">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                    (column.field === 'averageEpsGrowthYear15Id017') ||
                                    (column.field === 'averageEpsGrowthYear10Id016') ||
                                    (column.field === 'averageEpsGrowthYear5Id015'))">

                                    <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                    <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                        {{ 0 }}%
                                    </span>
                                    <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                        {{ 0 }}%
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ isNaN(data[column.field]) ? '0' : formatAmount(data[column.field]) }}%
                                    </span>

                                </span>

                                <span v-else-if="((column.field === 'epsIncreasesYear20Id097') ||
                                    (column.field === 'epsIncreasesYear15Id096') ||
                                    (column.field === 'epsIncreasesYear10Id095') ||
                                    (column.field === 'epsIncreasesYear5Id094'))">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="data[column.field] >= 8">
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'adgYear20Id009') ||
                                    (column.field === 'adgYear15Id008') ||
                                    (column.field === 'adgYear10Id007') ||
                                    (column.field === 'adgYear5Id006'))">
                                    <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                    <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                        {{ 0 }}%
                                    </span>
                                    <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                        {{ 0 }}%
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ isNaN(data[column.field]) ? '0' : formatAmount(data[column.field]) }}%
                                    </span>

                                </span>

                                <span v-else-if="((column.field === 'divYieldOnCost') ||
                                    (column.field === 'investmentReturn'))">

                                    <span>
                                        {{ isNaN(data[column.field]) ? '0' : formatAmount(data[column.field]) }}%
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'payoutRatioId107')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'afdPreviousId005')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] >= 0)">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'shareBuybackId122')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                    <span v-else :class="'highlight'">No</span>
                                </span>

                                <span v-else-if="(column.field === 'peRatioId104')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                    <span v-else :class="'highlight'">Over-valued</span>
                                </span>

                                <span v-else-if="(column.field === 'pbRatioId102')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                    (column.field === 'yearsEpsIncreasesId048') ||
                                    (column.field === 'employeesId093') ||
                                    (column.field === 'epsIncreasesYear5Id094') ||
                                    (column.field === 'epsIncreasesYear10Id095') ||
                                    (column.field === 'epsIncreasesYear15Id096') ||
                                    (column.field === 'epsIncreasesYear20Id097'))">
                                    <span v-if="data[column.field] === -9999.0">N/A</span>
                                    <span v-else>
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                    (column.field === 'companyAddressCountryId042') ||
                                    (column.field === 'companyAddressStateId043') ||
                                    (column.field === 'companyAddressId044') ||
                                    (column.field === 'companyDescriptionId045') ||
                                    (column.field === 'exchange') ||
                                    (column.field === 'name') ||
                                    (column.field === 'companyNameId046') ||
                                    (column.field === 'industryId081') ||
                                    (column.field === 'marketId089') ||
                                    (column.field === 'sectorId121') ||
                                    (column.field === 'websiteId136') ||
                                    (column.field === 'dividendCurrencyId062') ||
                                    (column.field === 'dividendFrequencyId063') ||
                                    (column.field === 'dividendPaymentDateId068') ||
                                    (column.field === 'dividendRecordDateId069') ||
                                    (column.field === 'exDividendDateId074') ||
                                    (column.field === 'fiscalYearendDateId075') ||
                                    (column.field === 'dividendPaidId070') ||
                                    (column.field === 'sharePriceDateId124'))">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else>
                                    <span v-if="data[column.field] === -9999.0">N/A</span>
                                    <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                    <span v-else>
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <h3>Add Stock, Fund or ETF</h3>
                    <span>All fields are mandatory</span>
                    <br/><br/><br/>

                    <div class="field">
                        <label for="country">Exchange</label>
                        <Dropdown v-model="newTrackData.exchange" :options="exchanges" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">

                        <div class="field">
                            <label for="client">Company Name</label>
                            <AutoComplete
                                placeholder="Search by stock symbol or company name"
                                :dropdown="true"
                                :multiple="false"
                                v-model="newTrackData.stock"
                                :suggestions="filteredCodes"
                                @complete="searchCodes($event)"
                                field="label"
                                :class="{ 'p-invalid': submitted && !newTrackData.stock }"
                            />
                        </div>
                    </div>

                    <div class="field">
                        <label for="quantity">Quantity</label>
                        <InputNumber
                            id="quantity"
                            v-model="newTrackData.quantity"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <Button label="Add" :disabled="!canAddTrackDataStock" :loading="submitted" class="mr-2 mb-2"
                            @click="addTrackDataStock"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <h3>Update Stock, Fund or ETF</h3>

                    <div class="field">
                        <label for="exchange">Exchange</label>
                        <InputText id="exchange" v-model.trim="existingTrackData.exchange" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="code">Code</label>
                        <InputText id="code" v-model.trim="existingTrackData.code" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="quantity">Quantity</label>
                        <InputNumber
                            id="quantity"
                            v-model="existingTrackData.quantity"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="unitPurchasePrice">Unit Purchase Price</label>
                        <InputNumber
                            id="unitPurchasePrice"
                            v-model="existingTrackData.unitPurchasePrice"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="2"/>
                    </div>

                    <div class="field">
                        <label for="brokerageName">Brokerage Name</label>
                        <InputText id="brokerageName" v-model.trim="existingTrackData.brokerageName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="brokerageFee">Brokerage Fee</label>
                        <InputNumber
                            id="brokerageFee"
                            v-model="existingTrackData.brokerageFee"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="2"/>
                    </div>


                    <div class="field">
                        <label for="accountType">Account Type</label>
                        <InputText id="accountType" v-model.trim="existingTrackData.accountType" required="true"/>
                    </div>

                    <div class="field">
                        <label for="paid">Purchased Date</label>
                        <Calendar id="paid" v-model="existingTrackData.purchased" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>


                    <Button label="Update" class="mr-2 mb-2" :disabled="!canUpdateTrackDataStock" :loading="submitted"
                            @click="updateTrackData"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>

                        </ul>
                    </div>

                    <h3>Delete Information for {{ this.existingTrackData.name }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Information?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteTrackData"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 8" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>

                    <h3>Add Other Income</h3>
                    <span>All fields are mandatory</span>
                    <br/><br/><br/>

                    <div class="field">
                        <label for="country">Country</label>
                        <Dropdown v-model="newTrackData.country" :options="countries" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newTrackData.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="annualIncome">Annual Income</label>
                        <InputNumber
                            id="annualIncome"
                            v-model="newTrackData.annualIncome"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="value">Market Value</label>
                        <InputNumber
                            id="value"
                            v-model="newTrackData.value"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="paid">Purchased Date</label>
                        <Calendar id="paid" v-model="newTrackData.purchased" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <Button label="Add" :disabled="!canAddOtherIncome" :loading="submitted" class="mr-2 mb-2"
                            @click="addTrackDataOther"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>

                    <h3>Update Other Income</h3>

                    <div class="field">
                        <label for="country">Country</label>
                        <InputText id="country" v-model.trim="existingTrackData.country" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="existingTrackData.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="accountType">Account Type</label>
                        <InputText id="accountType" v-model.trim="existingTrackData.accountType" required="true"/>
                    </div>

                    <div class="field">
                        <label for="annualIncome">Annual Income</label>
                        <InputNumber
                            id="annualIncome"
                            v-model="existingTrackData.annualIncome"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputNumber
                            id="value"
                            v-model="existingTrackData.value"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="paid">Purchased Date</label>
                        <Calendar id="paid" v-model="existingTrackData.purchased" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateTrackData"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Portfolio Growth Simulator</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callPortfolioGrowthSimulatorSettings" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Configure Portfolio Growth Simulator</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callFeesTable" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Fee Table</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>

                    <DataTable ref="investmentTable" :value="investmentTable" dataKey="id" :rows="30" striped-rows
                               responsiveLayout="scroll">

                        <Column field="year" header="Year">
                            <template #body="slotProps">
                                <span class="p-column-title">Year</span>
                                {{ slotProps.data.yearNumber }}
                            </template>
                        </Column>

                        <Column field="year">
                            <template #body="slotProps">
                                <span class="p-column-title"></span>
                                {{ slotProps.data.year }}
                            </template>
                        </Column>

                        <Column field="startingBalance" header="Starting Balance">
                            <template #body="slotProps">
                                <span class="p-column-title">Starting Balance</span>
                                {{ formatAmount(slotProps.data.startingBalance) }}
                            </template>
                        </Column>

                        <Column field="additionalInvestment" header="Annual Additional Investment">
                            <template #body="slotProps">
                                <span class="p-column-title">Annual Additional Investment</span>
                                {{ formatAmount(slotProps.data.additionalInvestment) }}
                            </template>
                        </Column>

                        <Column field="dividendsEarned" header="Dividends Earned">
                            <template #body="slotProps">
                                <span class="p-column-title">Dividends Earned</span>
                                {{ formatAmount(slotProps.data.dividendsEarned) }}
                            </template>
                        </Column>

                        <Column field="endingStockValue" header="Ending Stock Value">
                            <template #body="slotProps">
                                <span class="p-column-title">Ending Stock Value</span>
                                {{ formatAmount(slotProps.data.endingStockValue) }}
                            </template>
                        </Column>

                        <Column field="livingExpenses" header="Living Expenses">
                            <template #body="slotProps">
                                <span class="p-column-title">Living Expenses</span>
                                {{ formatAmount(slotProps.data.livingExpenses) }}
                            </template>
                        </Column>

                        <Column field="endingBalance" header="Ending Balance">
                            <template #body="slotProps">
                                <span class="p-column-title">Ending Balance</span>
                                {{ formatAmount(slotProps.data.endingBalance) }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid w-full">

                    <h3>Fee Table</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callPortfolioGrowthSimulator" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Portfolio Growth Simulator</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>


                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">

                                <br/>
                                <!--                                <span>-->
                                <!--                                    Fee Table will be available shortly, it will show the fees you could incur for any-->
                                <!--                                    mutual-->
                                <!--                                    funds, index funds or ETFs you hold in your portfolio.-->
                                <!--                                </span>-->

                            </div>
                        </div>
                    </div>

                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">
                                &nbsp;
                            </div>
                        </div>
                    </div>

                    <DataTable ref="trackDataFees" :value="trackDataFees" dataKey="id" striped-rows
                               class="w-full" tableStyle="width: 100%; min-width: 50rem">

                        <Column field="fundName" header="Fund Name" :style="{ minWidth: '150rem' }"
                                headerClass="text-left" bodyClass="text-left">
                            <template #body="slotProps">
                                <span class="p-column-title">Fund Name</span>
                                {{ slotProps.data.companyNameId046 }}
                            </template>
                        </Column>

                        <Column field="symbol" header="Symbol" headerClass="custom-center-header" bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Symbol</span>
                                {{ slotProps.data.codeId129 }}
                            </template>
                        </Column>

                        <Column field="dividendYield" header="Dividend Yield" headerClass="custom-center-header"
                                bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Dividend Yield</span>
                                {{ formatAmount(slotProps.data.yieldId138) }}
                            </template>
                        </Column>

                        <Column field="currentAnnualDividendIncome" header="Current Annual Dividend Income"
                                headerClass="custom-center-header" bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Current Annual Dividend Income</span>
                                {{ formatAmount(slotProps.data.fwdAnnDivIncome) }}
                            </template>
                        </Column>

                        <Column field="marketValue" header="Market Value" headerClass="custom-center-header"
                                bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Market Value</span>
                                {{ formatAmount(slotProps.data.marketValue) }}
                            </template>
                        </Column>

                        <Column field="mer" header="MER" headerClass="custom-center-header" bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">MER</span>
                                {{ formatAmount(slotProps.data.expenseRatioId137) }}
                            </template>
                        </Column>

                        <Column field="fees10Years" header="Fees After 10 Years" headerClass="custom-center-header"
                                bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Fees After 10 Years</span>
                                {{ formatAmount(slotProps.data.totalFees10Years) }}
                            </template>
                        </Column>

                        <Column field="fees20Years" header="Fees After 20 Years" headerClass="custom-center-header"
                                bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Fees After 20 Years</span>
                                {{ formatAmount(slotProps.data.totalFees20Years) }}
                            </template>
                        </Column>

                        <Column field="fees40Years" header="Fees After 40 Years" headerClass="custom-center-header"
                                bodyClass="text-center">
                            <template #body="slotProps">
                                <span class="p-column-title">Fees After 40 Years</span>
                                {{ formatAmount(slotProps.data.totalFees40Years) }}
                            </template>
                        </Column>

                        <ColumnGroup type="footer">
                            <Row>
                                <Column :colspan="2" />
                                <Column footer="Total:" footerClass="text-center" />
                                <Column :footer="totalFeesFwdAnnDivIncome.toFixed(2)" footerClass="text-center" />
                                <Column :footer="totalFeesMarketValue.toFixed(2)" footerClass="text-center" />
                                <Column />
                                <Column :footer="totalFees10Years.toFixed(2)" footerClass="text-center" />
                                <Column :footer="totalFees20Years.toFixed(2)" footerClass="text-center" />
                                <Column :footer="totalFees40Years.toFixed(2)" footerClass="text-center" />
                            </Row>

                            <Row>
                                <Column :colspan="2" />
                                <Column footer="Portfolio Yield:" footerClass="text-center" />
                                <Column :footer="feesPortfolioYield.toFixed(2) + '%'" footerClass="text-center" />
                                <Column />
                                <Column />
                                <Column />
                                <Column />
                                <Column />
                            </Row>
                        </ColumnGroup>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 12" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Configure Portfolio Growth Simulator</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callPortfolioGrowthSimulatorDashboard" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Portfolio Growth Simulator</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callMockPortfolio" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Mock Portfolio</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callFeesTable" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Fee Table</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callBackToSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>


                    <div class="col-12 md:col-12">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">

                                <div class="field">
                                    <label for="startingBalance">Starting Balance</label>
                                    <InputNumber
                                        id="startingBalance"
                                        v-model="achieveConfiguration.startingBalance"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div class="field">
                                    <label for="additionalInvestment">Annual Additional Investment</label>
                                    <InputNumber
                                        id="additionalInvestment"
                                        v-model="achieveConfiguration.additionalInvestment"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div class="field">
                                    <label for="dividendYield">Dividend Yield</label>
                                    <InputNumber
                                        id="dividendYield"
                                        v-model="achieveConfiguration.dividendYield"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="2"/>
                                </div>

                                <div class="field">
                                    <label for="shareGrowth">Share Growth</label>
                                    <InputNumber
                                        id="shareGrowth"
                                        v-model="achieveConfiguration.shareGrowth"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="2"/>
                                </div>

                                <div class="field">
                                    <label for="useInflation">Do You Want to Compare Against Annual Living
                                        Expenses?</label>
                                    <Dropdown v-model="achieveConfiguration.useLivingExpenses"
                                              :options="confirmationTypes" optionLabel="name" optionValue="code"
                                              placeholder="Select an Option"/>
                                </div>

                                <div v-if="this.achieveConfiguration.useLivingExpenses === 'Y'" class="field">
                                    <label for="expensesAccommodation">Living Expenses (Accommodation)</label>
                                    <InputNumber
                                        id="expensesAccommodation"
                                        v-model="achieveConfiguration.expensesAccommodation"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div v-if="this.achieveConfiguration.useLivingExpenses === 'Y'" class="field">
                                    <label for="expensesTravel">Living Expenses (Travel)</label>
                                    <InputNumber
                                        id="expensesTravel"
                                        v-model="achieveConfiguration.expensesTravel"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div v-if="this.achieveConfiguration.useLivingExpenses === 'Y'" class="field">
                                    <label for="expensesGroceries">Living Expenses (Groceries)</label>
                                    <InputNumber
                                        id="expensesGroceries"
                                        v-model="achieveConfiguration.expensesGroceries"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div v-if="this.achieveConfiguration.useLivingExpenses === 'Y'" class="field">
                                    <label for="expensesEntertainment">Living Expenses (Entertainment)</label>
                                    <InputNumber
                                        id="expensesEntertainment"
                                        v-model="achieveConfiguration.expensesEntertainment"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <div v-if="this.achieveConfiguration.useLivingExpenses === 'Y'" class="field">
                                    <label for="expensesEntertainment">Living Expenses (Miscellaneous)</label>
                                    <InputNumber
                                        id="expensesMiscellaneous"
                                        v-model="achieveConfiguration.expensesMiscellaneous"
                                        mode="decimal"
                                        :min="0"
                                        :maxFractionDigits="0"/>
                                </div>

                                <Button label="Save" class="mr-2 mb-2" @click="saveAchieveInfo"></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="activeTab === 13" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Contact Support</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="supportData.type" :options="supportTypes" optionLabel="name"
                                  optionValue="name"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="description">Short Summary</label>
                        <InputText id="description" v-model.trim="supportData.description" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Detailed Summary</label>
                        <Editor v-model="supportData.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Submit" class="mr-2 mb-2" :loading="submitted" @click="processSupport"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 14" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Support Request Confirmed</h3>

                    <span>
                        Your support request has been submitted to the Simply Investing team. You will receive a response shortly.
                        <br/>
                    </span>

                    <span>
                        <br/><br/>
                    </span>

                    <Button label="Back" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 15" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="col-12">
                        <div class="card">
                            <h3>Stock Data for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card">
                                    <Button label="Back" class="mr-2 mb-2" @click="restoreToOriginal"></Button>
                                </div>
                            </div>


                            <h3>Key Information for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-4">
                                    <label for="codeId129" style="font-weight: bold;">Stock Symbol</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.codeId129 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="lastname2" style="font-weight: bold;">Currency</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendCurrencyId062 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="epsTtmId071" style="font-weight: bold;">EPS (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.epsTtmId071) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceId123" style="font-weight: bold;">Share Price</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.sharePriceId123 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="exchangeId073" style="font-weight: bold;">Exchange</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.exchangeId073 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="payoutRatioId107" style="font-weight: bold;">Payout Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.payoutRatioId107) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceDateId124" style="font-weight: bold;">Share Price Date</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.sharePriceDateId124 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="peRatioId104" style="font-weight: bold;">PE Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.peRatioId104) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="longtermDebtEquityRatioId084" style="font-weight: bold;">Long-term
                                        Debt/Equity Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.longtermDebtEquityRatioId084) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="afdId004" style="font-weight: bold;">Forward Annual Dividend</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.afdId004) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="pbRatioId102" style="font-weight: bold;">PB Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.pbRatioId102) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="dividendPaidId070" style="font-weight: bold;">Dividends Paid
                                        Since</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendPaidId070 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="firstname2" style="font-weight: bold;">Dividend Yield</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.currentDividendYieldId050) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="marketCapitalisationId090" style="font-weight: bold;">Market
                                        Capitalization</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.marketCapitalisationId090) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="shareBuybackId122" style="font-weight: bold;">Share Buyback?</label>
                                    <br/>

                                    <span v-if="this.specificStockData.shareBuybackId122 === 'Y'">Yes</span>
                                    <span v-else>No</span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="employeesId093" style="font-weight: bold;">Number of Employees</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.employeesId093 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="industryId081" style="font-weight: bold;">Industry</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.industryId081 }}
                                    </span>
                                </div>

                                <div class="field col-12 md:col-4">
                                    <label for="undervaluedVsOvervaluedStatusYear20Id135"
                                           style="font-weight: bold;">Undervalued/overvalued
                                        (20-yr)</label>
                                    <br/>
                                    <span
                                        v-if="this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 === 'U'">
                                        Undervalued
                                    </span>
                                    <span
                                        v-else-if="this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 === 'O'">
                                        Overvalued
                                    </span>
                                    <span v-else>Unknown</span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="address" style="font-weight: bold;">Address</label>
                                    <br/>
                                    <span>
                                        {{
                                            this.specificStockData.companyAddressId044 + ', ' +
                                            this.specificStockData.companyAddressCityId041 + ' ' +
                                            this.specificStockData.companyAddressStateId043 + ' ' +
                                            this.specificStockData.companyAddressCountryId042
                                        }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="websiteId136" style="font-weight: bold;">Website</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.websiteId136 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="siCriteriaYear20Id128" style="font-weight: bold;">SI Criteria
                                        (20-yr)</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.siCriteriaYear20Id128 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-12">
                                    <label for="companyDescriptionId045" style="font-weight: bold;">Company
                                        Description</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.companyDescriptionId045 }}
                                    </span>
                                </div>

                            </div>

                            <div class="field col-12">&nbsp;</div>

                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <h3>Stock History for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable :value="stockHistory" :striped-rows="true" :reorderableColumns="true"
                                       :rowHover="true" :sortMode="'multiple'" dataKey="id"
                                       class="p-datatable-gridlines">

                                <template #empty>
                                    No stock history found.
                                </template>

                                <Column field="year" header="Year" :sortable="true"
                                        style="max-width: 50px; min-width: 50px" frozen>
                                    <template #body="{ data }">
                                        {{ data.year }}
                                    </template>
                                </Column>

                                <Column field="dividendPerShare" header="Dividend Per Share" :sortable="true"
                                        style="max-width: 50px; min-width: 50px; text-align: right;">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.dividendPerShare || data.dividendPerShare === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.dividendPerShare) }}
                                        </span>

                                    </template>
                                </Column>

                                <Column field="averageDividendYield" header="Average Dividend Yield"
                                        style="max-width: 50px; min-width: 50px" :sortable="true">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.averageDividendYield || data.averageDividendYield === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.averageDividendYield) }}
                                        </span>
                                    </template>
                                </Column>

                                <Column field="eps" header="EPS" style="max-width: 50px; min-width: 50px"
                                        :sortable="true">
                                    <template #body="{ data }">
                                        <span v-if="(!data.eps || data.eps === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.eps) }}
                                        </span>

                                    </template>
                                </Column>

                                <Column field="averagePeRatio" header="Average P/E Ratio"
                                        style="max-width: 50px; min-width: 50px" :sortable="true">
                                    <template #body="{ data }">
                                        <span
                                            v-if="data.year === 2025 && (!data.averagePeRatio || data.averagePeRatio === 0)">
                                          avail aft CYE
                                        </span>

                                        <span v-else>
                                          {{ formatAmount(data.averagePeRatio) }}
                                        </span>
                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="card">
                            <h3>SI Criteria for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable :value="specificStockDataArray"
                                       :loading="loading" :striped-rows="true"
                                       :reorderableColumns="true" :rowHover="true" dataKey="id"
                                       responsiveLayout="scroll"
                                       class="p-datatable-gridlines">

                                <template #header>

                                    <div class="col-12">
                                        <div class="card p-fluid">
                                            <div class="grid">

                                                <div class="col-12 lg:col-8 p-3">
                                                    <MultiSelect v-model="selectedColumnsForStockData"
                                                                 :options="columnConfigFullListStockData"
                                                                 optionLabel="header"
                                                                 optionValue="field"
                                                                 @change="onToggleColumnsForStockData"
                                                                 display="chip"
                                                                 placeholder="Select Columns"
                                                                 :filter="true"
                                                                 filterPlaceholder="Search columns..."
                                                                 :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                </div>

                                                <div class="col-12 lg:col-2 p-3">
                                                    <Dropdown v-model="selectedCustomFilterForStockData"
                                                              :options="customFiltersActive"
                                                              optionLabel="name" optionValue="id"
                                                              placeholder="Select a Custom Filter"
                                                              @change="onCustomFilterChangeForStockData"/>
                                                </div>

                                                <div class="col-12 lg:col-2 p-3">
                                                    <Dropdown v-model="selectedFormatForStockData" :options="formats"
                                                              optionLabel="name"
                                                              optionValue="code" placeholder="Select a Format"
                                                              @change="onFormatChangeForStockData"/>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </template>

                                <template #empty>
                                    No stock data found.
                                </template>

                                <template #loading>
                                    Loading stock data. Please wait.
                                </template>

                                <Column v-for="column in filteredColumnsForSearch" :key="column.field"
                                        :field="column.field"
                                        :sortable="column.sortable" :style="column.style"
                                        :frozen="column.frozen || false">

                                    <template #header>
                                            <span v-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))"
                                                  v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))"
                                              v-tooltip="'[undervalued]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))" v-tooltip="'[8% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'pbRatioId102')"
                                              v-tooltip="'[3 or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'peRatioId104')"
                                              v-tooltip="'[25 or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'shareBuybackId122')"
                                              v-tooltip="'[yes]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'afdPreviousId005')"
                                              v-tooltip="'[0% or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')"
                                              v-tooltip="'[70% or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'payoutRatioId107')"
                                              v-tooltip="'[75% or less]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear20Id097')"
                                              v-tooltip="'[8 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear15Id096')"
                                              v-tooltip="'[6 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear10Id095')"
                                              v-tooltip="'[4 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else-if="(column.field === 'epsIncreasesYear5Id094')"
                                              v-tooltip="'[2 or more]'">
                                                {{ column.header }}
                                            </span>

                                        <span v-else>
                                                {{ column.header }}
                                            </span>
                                    </template>

                                    <template #body="{ data }">

                                            <span v-if="column.field === 'codeId129'">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="column.field === 'sharePriceId123'">
                                                {{ formatAmount(data[column.field]) }}
                                            </span>

                                        <span v-else-if="column.field === 'currentDividendYieldId050'">
                                                {{ formatAmount(data[column.field]) }}%

                                                <span v-if="((data[column.field] > maxDividendYield) &&
                                                    ((this.selectedStandardFilter != 'DOW30') && (this.selectedStandardFilter != 'TSX60')))"
                                                      :class="'status-badge status-DT'"
                                                      @click="handleDividendTrapInfo(data)">DT
                                                </span>

                                            </span>

                                        <span v-else-if="((column.field === 'siCriteriaYear20Id128') ||
                                                (column.field === 'siCriteriaYear15Id127') ||
                                                (column.field === 'siCriteriaYear10Id126') ||
                                                (column.field === 'siCriteriaYear5Id125'))">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="column.field === 'companyNameId046'">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else-if="((column.field === 'averageEpsGrowthYear20Id018') ||
                                                (column.field === 'averageEpsGrowthYear15Id017') ||
                                                (column.field === 'averageEpsGrowthYear10Id016') ||
                                                (column.field === 'averageEpsGrowthYear5Id015'))">

                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                        <span v-else-if="((column.field === 'epsIncreasesYear20Id097') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear5Id094'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="data[column.field] >= 8">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'adgYear20Id009') ||
                                                (column.field === 'adgYear15Id008') ||
                                                (column.field === 'adgYear10Id007') ||
                                                (column.field === 'adgYear5Id006'))">
                                                <span v-if="!isNaN(data[column.field]) && data[column.field] >= 8">
                                                    {{ formatAmount(data[column.field]) }}%
                                                </span>
                                                <span v-else-if="data[column.field] == -9999" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else-if="isNaN(data[column.field])" :class="'highlight'">
                                                    {{ 0 }}%
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{
                                                        isNaN(data[column.field]) ? '0' : formatAmount(data[column.field])
                                                    }}%
                                                </span>

                                            </span>

                                        <span v-else-if="(column.field === 'payoutRatioId107')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'afdPreviousId005')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] >= 0)">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="(column.field === 'shareBuybackId122')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                                <span v-else :class="'highlight'">No</span>
                                            </span>

                                        <span v-else-if="(column.field === 'peRatioId104')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                                (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                                <span v-else :class="'highlight'">Over-valued</span>
                                            </span>

                                        <span v-else-if="(column.field === 'pbRatioId102')">
                                                <span v-if="data[column.field] === -9999.0"
                                                      :class="'highlight'">N/A</span>
                                                <span
                                                    v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                                <span v-else :class="'highlight'">
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                                (column.field === 'yearsEpsIncreasesId048') ||
                                                (column.field === 'employeesId093') ||
                                                (column.field === 'epsIncreasesYear5Id094') ||
                                                (column.field === 'epsIncreasesYear10Id095') ||
                                                (column.field === 'epsIncreasesYear15Id096') ||
                                                (column.field === 'epsIncreasesYear20Id097'))">
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else>
                                                    {{ formatNumeric(data[column.field]) }}
                                                </span>
                                            </span>

                                        <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                                (column.field === 'companyAddressCountryId042') ||
                                                (column.field === 'companyAddressStateId043') ||
                                                (column.field === 'companyAddressId044') ||
                                                (column.field === 'companyDescriptionId045') ||
                                                (column.field === 'industryId081') ||
                                                (column.field === 'marketId089') ||
                                                (column.field === 'sectorId121') ||
                                                (column.field === 'websiteId136') ||
                                                (column.field === 'dividendCurrencyId062') ||
                                                (column.field === 'dividendFrequencyId063') ||
                                                (column.field === 'dividendPaymentDateId068') ||
                                                (column.field === 'dividendRecordDateId069') ||
                                                (column.field === 'exDividendDateId074') ||
                                                (column.field === 'fiscalYearendDateId075') ||
                                                (column.field === 'dividendPaidId070') ||
                                                (column.field === 'sharePriceDateId124'))">
                                                {{ data[column.field] }}
                                            </span>

                                        <span v-else>
                                                <span v-if="data[column.field] === -9999.0">N/A</span>
                                                <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                                <span v-else>
                                                    {{ formatAmount(data[column.field]) }}
                                                </span>
                                            </span>

                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <h3>Graph for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card p-fluid">
                                    <div class="grid">

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataTimePeriod" :options="timePeriodsGraph"
                                                      optionLabel="name" optionValue="code"
                                                      placeholder="Select a Time Period"
                                                      @change="onStockDataTimePeriodChange"/>
                                        </div>

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataStockHistoryOption"
                                                      :options="stockHistoryOptions" optionLabel="name"
                                                      optionValue="code"
                                                      placeholder="Select a Format"
                                                      @change="onStockDataStockHistoryOptionChange"/>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <Chart type="line" :data="lineData" :options="lineOptions" :key="chartKey"></Chart>
                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <Button label="Back" class="mr-2 mb-2" @click="restoreToOriginal"></Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>


    </div>

    <SiFooter/>
</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import TrackDataService from "@/service/TrackDataService";
import StockService from "@/service/StockService";
import moment from "moment";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import numeral from "numeral";
import FilterComponentService from "@/service/FilterComponentService";
import FilterService from "@/service/FilterService";
import ClientService from "@/service/ClientService";
import TaskService from "@/service/TaskService";
import Chart from "primevue/chart";
import {
    STOCK_DATA_COLUMNS_BASIC_SEARCH,
    STOCK_DATA_COLUMNS_EXTENDED,
    STOCK_DATA_COLUMNS_FULL, STOCK_DATA_COLUMNS_MINIMAL
} from "@/config/stockdata";
import StockHistoryService from "@/service/StockHistoryService";
import StockDataService from "@/service/StockDataService";

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        Chart, DataTable, Column, ColumnGroup, Row,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    computed: {
        canAddTrackDataStock() {
            return (
                this.newTrackData.exchange &&
                this.newTrackData.stock &&
                this.newTrackData.quantity !== null &&
                this.newTrackData.quantity !== undefined
            );
        },
        canAddOtherIncome() {
            return (
                this.newTrackData.country &&
                this.newTrackData.name &&
                this.newTrackData.annualIncome !== null &&
                this.newTrackData.annualIncome !== undefined &&
                this.newTrackData.value !== null &&
                this.newTrackData.value !== undefined &&
                this.newTrackData.purchased
            );
        },
        canUpdateTrackDataStock() {
            return (
                this.existingTrackData.exchange &&
                this.existingTrackData.code &&
                this.existingTrackData.quantity !== null &&
                this.existingTrackData.quantity !== undefined &&
                this.existingTrackData.unitPurchasePrice !== null &&
                this.existingTrackData.unitPurchasePrice !== undefined &&
                this.existingTrackData.accountType &&
                this.existingTrackData.purchased
            );
        },
        filteredColumnsForSearch() {
            const filtered = this.columnConfigFullListStockData.filter(column => {
                return this.selectedColumnsForStockData.includes(column.field);
            });

            return filtered;
        },
        totalFeesFwdAnnDivIncome() {
            return this.trackDataFees.reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
        },
        totalFeesMarketValue() {
            return this.trackDataFees.reduce((sum, item) => sum + (item.marketValue || 0), 0);
        },
        totalFees10Years() {
            return this.trackDataFees.reduce((sum, item) => sum + (item.totalFees10Years || 0), 0);
        },
        totalFees20Years() {
            return this.trackDataFees.reduce((sum, item) => sum + (item.totalFees20Years || 0), 0);
        },
        totalFees40Years() {
            return this.trackDataFees.reduce((sum, item) => sum + (item.totalFees40Years || 0), 0);
        },
        feesPortfolioYield() {
            return ( (this.trackDataFees.reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0) / this.trackDataFees.reduce((sum, item) => sum + (item.marketValue || 0), 0)) * 100.0);
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            const pingData = await UserService.getUserPing();
            console.log("[Achieve][mounted] System is active.");
            console.log("[Achieve][mounted] Data = ", pingData);
        } catch (e) {
            console.log("[Achieve][mounted] System is NOT active.");
            console.log("[Achieve][mounted] Error = ", e);

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;

        }

        if (this.userStore.user === undefined) {
            console.log("[Achieve][mounted] User is NOT defined.");

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;

        } else {
            console.log("[Achieve][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
                console.log("[Applications][mounted] Data = ", userData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 1;
                } else {
                    this.activeTab = 4;
                }

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfig = userConfigData.data;
                    console.log("[Achieve][mounted] this.userConfig = ", this.userConfig);

                    if (this.userConfig.enableSiUs === 'Y') {
                        var newEntry1 = {name: 'NYSE', code: 'NYSE'};
                        var newEntry2 = {name: 'NASDAQ', code: 'NASDAQ'};

                        this.exchanges.push(newEntry1);
                        this.exchanges.push(newEntry2);

                        var newCountryEntry1 = {name: 'United States', code: 'US'};
                        this.countries.push(newCountryEntry1);
                    }

                    if (this.userConfig.enableSiCa === 'Y') {
                        var newEntry3 = {name: 'TSX', code: 'TO'};

                        this.exchanges.push(newEntry3);

                        var newCountryEntry2 = {name: 'Canada', code: 'CA'};
                        this.countries.push(newCountryEntry2);
                    }

                    if (this.userConfig.enableSiUk === 'Y') {
                        var newEntry4 = {name: 'LSE', code: 'LSE'};
                        this.exchanges.push(newEntry4);

                        var newCountryEntry3 = {name: 'United Kingdom', code: 'UK'};
                        this.countries.push(newCountryEntry3);
                    }

                    if (this.userConfig.enableSiZa === 'Y') {
                        var newEntry5 = {name: 'JSE', code: 'JSE'};
                        this.exchanges.push(newEntry5);

                        var newCountryEntry4 = {name: 'South Africa', code: 'ZA'};
                        this.countries.push(newCountryEntry4);
                    }

                    console.log("[Achieve][mounted] this.exchanges = ", this.exchanges);
                    console.log("[Achieve][mounted] this.countries = ", this.countries);

                    this.achieveConfiguration.startingBalance = this.userConfig.siSimulatorStartingBalance;
                    this.achieveConfiguration.additionalInvestment = this.userConfig.siSimulatorAdditionalInvestment;
                    this.achieveConfiguration.useLivingExpenses = this.userConfig.siSimulatorCompareExpenses;
                    this.achieveConfiguration.dividendYield = this.userConfig.siSimulatorDividendYield;
                    this.achieveConfiguration.shareGrowth = this.userConfig.siSimulatorShareGrowth;
                    this.achieveConfiguration.expensesAccommodation = this.userConfig.siSimulatorExpensesAccommodation;
                    this.achieveConfiguration.expensesTravel = this.userConfig.siSimulatorExpensesTravel;
                    this.achieveConfiguration.expensesGroceries = this.userConfig.siSimulatorExpensesGroceries;
                    this.achieveConfiguration.expensesEntertainment = this.userConfig.siSimulatorExpensesEntertainment;
                    this.achieveConfiguration.expensesMiscellaneous = this.userConfig.siSimulatorExpensesMiscellaneous;

                    const [trackDataInfo] = await Promise.all([
                        TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                    ]);

                    this.trackData = trackDataInfo.data;
                    this.originalTrackData = trackDataInfo.data;

                    if (this.countries.length > 0) {
                        this.selectedCountry = this.countries[0].code;
                    }

                    if (this.selectedCountry === "ZA") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "ZA");
                    } else if (this.selectedCountry === "CA") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "CA");
                    } else if (this.selectedCountry === "UK") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "UK");
                    } else {
                        this.trackData = this.originalTrackData.filter(track => track.country === "US");
                    }

                    console.log("[Achieve][mounted] this.trackData = ", this.trackData);
                    console.log("[Achieve][mounted] this.selectedCountry = ", this.selectedCountry);

                    if (this.countries.length > 0) {
                        this.selectedCountry = this.countries[0].code;
                    }

                    await this.calculateTrackSummary();

                    this.selectedFormat = "Compact";

                    try {
                        const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                            FilterService.getUserFilters(this.userStore.user.id),
                            FilterService.getUserActiveFilters(this.userStore.user.id)
                        ]);

                        this.customFilters = customFilterInfo.data;
                        this.customFiltersActive = customFilterActiveInfo.data;
                        console.log("[Achieve][mounted] this.customFilters = ", this.customFilters);
                        console.log("[Achieve][mounted] this.customFiltersActive = ", this.customFiltersActive);

                    } catch (e) {
                        console.error("[Achieve][mounted] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    const [clientData] = await Promise.all([
                        ClientService.getClientForUser(this.userStore.user.id)
                    ]);

                    this.client = clientData.data;
                    console.log("[Achieve][mounted] this.client = ", this.client);

                    this.columnsDefault = [
                        {field: 'type', header: 'Type', sortable: true, frozen: true},
                        {field: 'country', header: 'Country', sortable: true, frozen: true},
                        {field: 'name', header: 'Name', sortable: true, frozen: true},
                        {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                        {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                        {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                        {field: 'currentDividendYieldId050', header: 'Current Div Yld', sortable: true},
                        {field: 'investmentReturn', header: 'Return', sortable: true},
                        {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                    ];

                    this.columnsFullList = [
                        {field: 'type', header: 'Type', sortable: true, frozen: true},
                        {field: 'country', header: 'Country', sortable: true, frozen: true},
                        {field: 'name', header: 'Name', sortable: true, frozen: true},
                        {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                        {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                        {field: 'investmentReturn', header: 'Return', sortable: true},
                        {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                        {field: 'quantity', header: 'Quantity', sortable: true},
                        {field: 'unitPurchasePrice', header: 'Unit Purchase Price', sortable: true},
                        {field: 'marketValue', header: 'Market Value', sortable: true},
                        {field: 'portfolioShare', header: '% of Portfolio', sortable: true},
                        {field: 'divYieldOnCost', header: 'Div Yield On Cost', sortable: true},
                        {field: 'accountType', header: 'Account Type', sortable: true},
                        {field: 'brokerageName', header: 'Brokerage Name', sortable: true},
                        {field: 'brokerageFee', header: 'Brokerage Fee', sortable: true},
                        {field: 'annualIncome', header: 'Annual Income', sortable: true},
                        {field: 'value', header: 'Value', sortable: true},
                        {field: 'purchased', header: 'Purchased', sortable: true},
                        {field: 'sold', header: 'Sold', sortable: true},
                        {field: "hspWeek52Id001", header: "52wk High", sortable: true},
                        {field: "lspWeek52Id002", header: "52wk Low", sortable: true},
                        {field: "altmanZscoreId003", header: "Altman Z-Score", sortable: true},
                        {field: "afdId004", header: "Annual Fwd Dividend", sortable: true},
                        {field: "afdPreviousId005", header: "R9 - Fwd Dividend vs Prev Year", sortable: true},
                        {field: "adgYear5Id006", header: "R6 - Avg Div Growth 5yr", sortable: true},
                        {field: "adgYear10Id007", header: "R6 - Avg Div Growth 10yr", sortable: true},
                        {field: "adgYear15Id008", header: "R6 - Avg Div Growth 15yr", sortable: true},
                        {field: "adgYear20Id009", header: "R6 - Avg Div Growth 20yr", sortable: true},
                        {field: "adyYear5Id010", header: "Avg Div Yld 5yr", sortable: true},
                        {field: "adyYear10Id011", header: "Avg Div Yld 10yr", sortable: true},
                        {field: "adyYear15Id012", header: "Avg Div Yld 15yr", sortable: true},
                        {field: "adyYear20Id013", header: "Avg Div Yld 20yr", sortable: true},
                        {field: "averageEpsYear3Id014", header: "Avg 3yr EPS", sortable: true},
                        {field: "averageEpsGrowthYear5Id015", header: "R5a - Avg EPS Growth 5yr", sortable: true},
                        {field: "averageEpsGrowthYear10Id016", header: "R5a - Avg EPS Growth 10yr", sortable: true},
                        {field: "averageEpsGrowthYear15Id017", header: "R5a - Avg EPS Growth 15yr", sortable: true},
                        {field: "averageEpsGrowthYear20Id018", header: "R5a - Avg EPS Growth 20yr", sortable: true},
                        {field: "averageHdyYear5Id019", header: "Avg High Div Yld 5yr", sortable: true},
                        {field: "averageHdyYear10Id020", header: "Avg High Div Yld 10yr", sortable: true},
                        {field: "averageHdyYear15Id021", header: "Avg High Div Yld 15yr", sortable: true},
                        {field: "averageHdyYear20Id022", header: "Avg High Div Yld 20yr", sortable: true},
                        {field: "averageHighPeRatioYear5Id023", header: "Avg High P/E 5yr", sortable: true},
                        {field: "averageHighPeRatioYear10Id024", header: "Avg High P/E 10yr", sortable: true},
                        {field: "averageHighPeRatioYear15Id025", header: "Avg High P/E 15yr", sortable: true},
                        {field: "averageHighPeRatioYear20Id026", header: "Avg High P/E 20yr", sortable: true},
                        {field: "averageLdyYear5Id027", header: "Avg Low Div Yld 5yr", sortable: true},
                        {field: "averageLdyYear10Id028", header: "Avg Low Div Yld 10yr", sortable: true},
                        {field: "averageLdyYear15Id029", header: "Avg Low Div Yld 15yr", sortable: true},
                        {field: "averageLdyYear20Id030", header: "Avg Low Div Yld 20yr", sortable: true},
                        {field: "averageLowPeRatioYear5Id031", header: "Avg Low P/E 5yr", sortable: true},
                        {field: "averageLowPeRatioYear10Id032", header: "Avg Low P/E 10yr", sortable: true},
                        {field: "averageLowPeRatioYear15Id033", header: "Avg Low P/E 15yr", sortable: true},
                        {field: "averageLowPeRatioYear20Id034", header: "Avg Low P/E 20yr", sortable: true},
                        {field: "averagePeRatioYear5Id035", header: "Avg P/E 5yr", sortable: true},
                        {field: "averagePeRatioYear10Id036", header: "Avg P/E 10yr", sortable: true},
                        {field: "averagePeRatioYear15Id037", header: "Avg P/E 15yr", sortable: true},
                        {field: "averagePeRatioYear20Id038", header: "Avg P/E 20yr", sortable: true},
                        {field: "bookValuePerShareId039", header: "Bk Value/Share", sortable: true},
                        {field: "cashFlowPerShareId040", header: "Cashflow/Share", sortable: true},
                        {field: "companyAddressCityId041", header: "City", sortable: true},
                        {field: "companyAddressCountryId042", header: "Country", sortable: true},
                        {field: "companyAddressStateId043", header: "State/Prov", sortable: true},
                        {field: "companyAddressId044", header: "Address", sortable: true},
                        {field: "companyDescriptionId045", header: "Description", sortable: true},
                        {field: "companyNameId046", header: "Name", sortable: true},
                        {field: "yearsDividendIncreasesId047", header: "Consecutive Yrs Div Increases", sortable: true},
                        {field: "yearsEpsIncreasesId048", header: "Consecutive Yrs EPS Increases", sortable: true},
                        {field: "currentAssetsId049", header: "Current Assets", sortable: true},
                        {field: "currentDividendYieldId050", header: "Current Div Yld", sortable: true},
                        {field: "currentLiabilitiesId051", header: "Current Debt", sortable: true},
                        {field: "currentRatioId052", header: "Current Ratio", sortable: true},
                        {
                            field: "diffDyCurrentVsAverageYear5Id053",
                            header: "Diff Between Current Div Yld & Avg Div Yld 5yrs",
                            sortable: true
                        },
                        {
                            field: "diffDyCurrentVsAverageYear10Id054",
                            header: "Diff Between Current Div Yld & Avg Div Yld 10yrs",
                            sortable: true
                        },
                        {
                            field: "diffDyCurrentVsAverageYear15Id055",
                            header: "Diff Between Current Div Yld & Avg Div Yld 15yrs",
                            sortable: true
                        },
                        {
                            field: "diffDyCurrentVsAverageYear20Id056",
                            header: "Diff Between Current Div Yld & Avg Div Yld 20yrs",
                            sortable: true
                        },
                        {
                            field: "diffPeCurrentVsAverageYear5Id057",
                            header: "Diff Between Current P/E & Avg P/E 5yrs",
                            sortable: true
                        },
                        {
                            field: "diffPeCurrentVsAverageYear10Id058",
                            header: "Diff Between Current P/E & Avg P/E 10yrs",
                            sortable: true
                        },
                        {
                            field: "diffPeCurrentVsAverageYear15Id059",
                            header: "Diff Between Current P/E & Avg P/E 15yrs",
                            sortable: true
                        },
                        {
                            field: "diffPeCurrentVsAverageYear20Id060",
                            header: "Diff Between Current P/E & Avg P/E 20yrs",
                            sortable: true
                        },
                        {field: "dcfId061", header: "DCF", sortable: true},
                        {field: "dividendCurrencyId062", header: "Div Currency", sortable: true},
                        {field: "dividendFrequencyId063", header: "Div Frequency", sortable: true},
                        {field: "dgPlusDyYear5Id064", header: "Div Gr (5yr) + Curr Div Yld", sortable: true},
                        {field: "dgPlusDyYear10Id065", header: "Div Gr (10yr) + Curr Div Yld", sortable: true},
                        {field: "dgPlusDyYear15Id066", header: "Div Gr (15yr) + Curr Div Yld", sortable: true},
                        {field: "dgPlusDyYear20Id067", header: "Div Gr (20yr) + Curr Div Yld", sortable: true},
                        {field: "dividendPaymentDateId068", header: "Div Payment Date", sortable: true},
                        {field: "dividendRecordDateId069", header: "Div Record Date", sortable: true},
                        {field: "dividendPaidId070", header: "Divs Paid Since", sortable: true},
                        {field: "epsTtmId071", header: "EPS (TTM)", sortable: true},
                        {field: "esgScoreId072", header: "ESG Score", sortable: true},
                        {field: "exDividendDateId074", header: "Ex-Div Date", sortable: true},
                        {field: "fiscalYearendDateId075", header: "Fiscal Yr End", sortable: true},
                        {field: "grahamPriceId076", header: "Graham Price", sortable: true},
                        {field: "hspYear5Id077", header: "High Price Using 5yr Data", sortable: true},
                        {field: "hspYear10Id078", header: "High Price Using 10yr Data", sortable: true},
                        {field: "hspYear15Id079", header: "High Price Using 15yr Data", sortable: true},
                        {field: "hspYear20Id080", header: "High Price Using 20yr Data", sortable: true},
                        {field: "industryId081", header: "Industry", sortable: true},
                        {field: "longtermDebtId082", header: "LT Debt", sortable: true},
                        {field: "longtermDebtVsTotalCapitalId083", header: "LT Debt/Total Capital", sortable: true},
                        {field: "longtermDebtEquityRatioId084", header: "R8 - LT Debt/Equity", sortable: true},
                        {field: "lspYear5Id085", header: "Low Price Using 5yr Data", sortable: true},
                        {field: "lspYear10Id086", header: "Low Price Using 10yr Data", sortable: true},
                        {field: "lspYear15Id087", header: "Low Price Using 15yr Data", sortable: true},
                        {field: "lspYear20Id088", header: "Low Price Using 20yr Data", sortable: true},
                        {field: 'marketId089', header: 'Market/Country', sortable: true},
                        {field: 'marketCapitalisationId090', header: 'Market Cap', sortable: true},
                        {field: 'netIncomeId091', header: 'Net Income', sortable: true},
                        {field: 'netIncomePerShareId092', header: 'Net Income/Share TTM', sortable: true},
                        {field: 'employeesId093', header: 'Employees', sortable: true},
                        {field: 'epsIncreasesYear5Id094', header: 'R5b - EPS Increases in 5yrs', sortable: true},
                        {field: 'epsIncreasesYear10Id095', header: 'R5b - EPS Increases in 10yrs', sortable: true},
                        {field: 'epsIncreasesYear15Id096', header: 'R5b - EPS Increases in 15yrs', sortable: true},
                        {field: 'epsIncreasesYear20Id097', header: 'R5b - EPS Increases in 20yrs', sortable: true},
                        {field: 'outstandingSharesCurrentYearId098', header: 'Share Outstanding', sortable: true},
                        {
                            field: 'outstandingSharesPreviousYearId099',
                            header: 'Share Outstanding (previous Yr)',
                            sortable: true
                        },
                        {field: 'operatingCashflowId100', header: 'Operating Cashflow', sortable: true},
                        {field: 'operatingCashflowRatioId101', header: 'Operating Cashflow Ratio', sortable: true},
                        {field: 'pbRatioId102', header: 'R11c - P/B Ratio', sortable: true},
                        {field: 'pcfRatioId103', header: 'P/CF Ratio', sortable: true},
                        {field: 'peRatioId104', header: 'R11a - P/E Ratio TTM', sortable: true},
                        {field: 'pfcfRatioId105', header: 'P/FCF Ratio', sortable: true},
                        {field: 'psRatioId106', header: 'P/S Ratio', sortable: true},
                        {field: 'payoutRatioId107', header: 'R7 - Payout Ratio', sortable: true},
                        {field: 'pegRatioYear5Id108', header: 'PEG Ratio Using Avg EPS Growth 5yr', sortable: true},
                        {field: 'pegRatioYear10Id109', header: 'PEG Ratio Using Avg EPS Growth 10yr', sortable: true},
                        {field: 'pegRatioYear15Id110', header: 'PEG Ratio Using Avg EPS Growth 15yr', sortable: true},
                        {field: 'pegRatioYear20Id111', header: 'PEG Ratio Using Avg EPS Growth 20yr', sortable: true},
                        {
                            field: 'diffGrahamPriceSharePriceId112',
                            header: '% diff Graham Price vs Share Price',
                            sortable: true
                        },
                        {field: 'sharesOwnedInstitutionsId113', header: '% Owned by Institutions', sortable: true},
                        {field: 'piotroskiFscoreId114', header: 'Piotroski F-Score', sortable: true},
                        {field: 'profitMarginId115', header: 'Total Operating Profit Margin', sortable: true},
                        {field: 'quickRatioId116', header: 'Quick Ratio', sortable: true},
                        {field: 'recentDividendPaymentId117', header: 'Recent Div Payment', sortable: true},
                        {field: 'roaTtmId118', header: 'ROA TTM', sortable: true},
                        {field: 'rocTtmId119', header: 'ROC TTM', sortable: true},
                        {field: 'roeTtmId120', header: 'ROE TTM', sortable: true},
                        {field: 'sectorId121', header: 'Sector', sortable: true},
                        {field: 'shareBuybackId122', header: 'R10 - Share Buyback?', sortable: true},
                        {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                        {field: 'sharePriceDateId124', header: 'Share Date & Time', sortable: true},
                        {field: 'siCriteriaYear5Id125', header: 'SI Criteria out of 10 (5yr Data)', sortable: true},
                        {field: 'siCriteriaYear10Id126', header: 'SI Criteria out of 10 (10yr Data)', sortable: true},
                        {field: 'siCriteriaYear15Id127', header: 'SI Criteria out of 10 (15yr Data)', sortable: true},
                        {field: 'siCriteriaYear20Id128', header: 'SI Criteria out of 10 (20yr Data)', sortable: true},
                        {field: 'codeId129', header: 'Stock Symbol', sortable: true},
                        {field: 'totalDebtVsEquityRatioId130', header: 'Total Debt/Equity Ratio', sortable: true},
                        {field: 'totalStockholderEquityId131', header: 'Total Stockholder Equity', sortable: true},
                        {
                            field: 'undervaluedVsOvervaluedStatusYear5Id132',
                            header: 'R11b - Under/Over Valued Using 5yr Data',
                            sortable: true
                        },
                        {
                            field: 'undervaluedVsOvervaluedStatusYear10Id133',
                            header: 'R11b - Under/Over Valued Using 10yr Data',
                            sortable: true
                        },
                        {
                            field: 'undervaluedVsOvervaluedStatusYear15Id134',
                            header: 'R11b - Under/Over Valued Using 15yr Data',
                            sortable: true
                        },
                        {
                            field: 'undervaluedVsOvervaluedStatusYear20Id135',
                            header: 'R11b - Under/Over Valued Using 20yr Data',
                            sortable: true
                        },
                        {field: 'websiteId136', header: 'Website', sortable: true}
                    ]

                    this.columnsCompactList = [
                        {field: 'type', header: 'Type', sortable: true, frozen: true},
                        {field: 'country', header: 'Country', sortable: true, frozen: true},
                        {field: 'name', header: 'Name', sortable: true, frozen: true},
                        {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                        {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                        {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                        {field: 'currentDividendYieldId050', header: 'Current Div Yld', sortable: true},
                        {field: 'investmentReturn', header: 'Return', sortable: true},
                        {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                    ];

                    this.columnsCompleteList = [
                        {field: 'type', header: 'Type', sortable: true, frozen: true},
                        {field: 'country', header: 'Country', sortable: true, frozen: true},
                        {field: 'name', header: 'Name', sortable: true, frozen: true},
                        {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                        {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                        {field: 'sharePriceId123', header: 'Share Price'},
                        {field: 'currentDividendYieldId050', header: 'Current Div Yld'},
                        {field: 'investmentReturn', header: 'Return', sortable: true},
                        {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                        {field: 'quantity', header: 'Quantity', sortable: true},
                        {field: 'averageEpsGrowthYear20Id018', header: 'R5a - Avg EPS Growth 20yr', sortable: true},
                        {field: 'epsIncreasesYear20Id097', header: 'R5b - EPS Increases in 20yrs', sortable: true},
                        {field: 'adgYear20Id009', header: 'R6 - Avg Div Growth 20yr', sortable: true},
                        {field: 'payoutRatioId107', header: 'R7 - Payout Ratio', sortable: true},
                        {field: 'longtermDebtEquityRatioId084', header: 'R8 - LT Debt/Equity', sortable: true},
                        {field: 'afdPreviousId005', header: 'R9 - Fwd Dividend vs Prev Year', sortable: true},
                        {field: 'shareBuybackId122', header: 'R10 - Share Buyback?', sortable: true},
                        {field: 'peRatioId104', header: 'R11a - P/E Ratio TTM', sortable: true},
                        {field: 'pbRatioId102', header: 'R11c - P/B Ratio', sortable: true},
                        {field: 'yearsDividendIncreasesId047', header: 'Consecutive Yrs Div Increases', sortable: true}
                    ]

                    this.selectedColumns = this.columnsDefault;

                    console.log("[Achieve][mounted] this.selectedColumns = ", this.selectedColumns);

                    this.loading = false;
                } catch (e) {
                    console.error("[Achieve][mounted] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }


            } catch (e) {
                console.error("[Achieve][mounted] Error fetching user data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        }
    },
    data() {

        return {
            activeTab: 1,
            submitted: false,
            loading: false,
            achieveConfiguration: {},
            userConfig: {},
            client: {},
            supportData: {},
            toggleCustomisePortfolioGrowth: false,
            toggleFeeTable: false,
            investmentTable: [],
            specificTrackData: {},
            newTrackData: {},
            existingTrackData: {},
            trackFundsActual: null,
            trackDataActual: null,
            originalTrackDataActual: null,
            trackDataProjected: null,
            originalTrackDataProjected: null,
            filteredCodes: [],
            trackData: [],
            originalTrackData: [],
            trackDataFees: [],
            filters: null,
            confirmationResponse: 'N',
            selectedColumns: [],  // Instead of null
            columnsDefault: [],
            columnsFullList: [],
            columnsCompactList: [],
            columnsCompleteList: [],
            selectedCustomFilter: "",
            customFiltersActive: [],
            totalIncomeStocksActual: null,
            totalIncomeFundsActual: null,
            totalIncomeBusinessesActual: null,
            totalIncomeStocksProjected: null,
            totalIncomeFundsProjected: null,
            totalIncomeBusinessesProjected: null,
            totalTrackFundsCurrentAnnualDivIncome: null,
            totalTrackFundsMarketValue: null,
            totalTrackFundsFees10yrs: null,
            totalTrackFundsFees20yrs: null,
            totalTrackFundsFees40yrs: null,
            totalTrackFundsPortfolioYield: null,
            totalAmountInvestedProjected: 0.0,
            selectedStandardFilter: "All",
            selectedExchange: "All",
            selectedCountry: "US",
            selectedFormat: "Compact",
            columnConfigBasicStockData: STOCK_DATA_COLUMNS_BASIC_SEARCH,
            columnConfigExtendedStockData: STOCK_DATA_COLUMNS_EXTENDED,
            columnConfigFullListStockData: STOCK_DATA_COLUMNS_FULL,
            selectedColumnsForStockData: STOCK_DATA_COLUMNS_MINIMAL.map(column => column.field),
            selectedFormatForStockData: "Compact",
            selectedStockDataTimePeriod: "20",
            selectedStockDataStockHistoryOption: "DPS",
            pieData: {},
            pieOptions: {},
            lineData: [],
            lineOptions: [],
            chartKey: 0,
            specificStockData: {},
            specificStockDataArray: [],
            selectedCustomFilterForStockData: "",
            stockHistory: [],
            maxDividendYield: 0.0,
            timePeriodsGraph: [
                {name: '20 Year', code: '20'},
                {name: '15 Year', code: '15'},
                {name: '10 Year', code: '10'},
                {name: '5 Year', code: '5'},
                {name: 'Maximum', code: 'Maximum'},
            ],
            stockHistoryOptions: [
                {name: 'Dividends Per Share', code: 'DPS'},
                {name: 'Low Price', code: 'LSP'},
                {name: 'High Price', code: 'HSP'},
                {name: 'Average Price', code: 'ASP'},
                {name: 'EPS', code: 'EPS'}
            ],
            formats: [
                {name: 'Minimal View', code: 'Compact'},
                {name: 'Extended View', code: 'Complete'}
            ],
            countries: [],
            exchanges: [],
            standardFilters: [
                {name: 'All', code: 'All'},
                {name: 'Stocks', code: 'Stocks'},
                {name: 'Funds', code: 'Funds'},
                {name: 'ETFs', code: 'ETFs'},
                {name: 'Other Income', code: 'Income'},
                {name: 'Sold', code: 'Sold'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            supportTypes: [
                {name: 'Technical Issue', code: 'Technical Issue'},
                {name: 'Billing & Payments', code: 'Billing & Payments'},
                {name: 'Account Management', code: 'Account Management'},
                {name: 'Feature Request', code: 'Feature Request'},
                {name: 'How-To / Usage Questions', code: 'How-To / Usage Questions'},
                {name: 'Performance Issues', code: 'Performance Issues'},
                {name: 'Other', code: 'Other'}
            ]
        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'exchangeId073': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'codeId129': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            // window.location.reload();

            this.activeTab = 4;
            this.selectedCustomFilter = "";
            this.customFiltersActive = [];
            this.customFilters = [];
            this.selectedColumns = this.columnsDefault;
            this.selectedFormat = "Compact";

            this.callMockPortfolio();
        },
        callReset() {
            this.activeTab = 3;
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        callHelp() {
            console.log('[TrackData][callHelp] Start.');
        },
        callSupport() {
            this.supportData = {};
            this.supportData.type = "Feature Request";

            this.newTask = {
                type: 'S',
                severity: 'N',
                category: 'F',
                priority: 1,
                max: 259200,
                clientVisible: 'N',
                due: moment().add(5, 'days').startOf('hour').toDate()
            };

            this.activeTab = 13;
        },
        onToggleColumns(value) {
            const dropdown = document.querySelector('.p-multiselect-panel .p-multiselect-items');
            const scrollPosition = dropdown ? dropdown.scrollTop : 0;

            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));

            this.$nextTick(() => {
                if (dropdown) {
                    dropdown.scrollTop = scrollPosition;  // Restore scroll position
                }
            });
        },
        onToggleColumnsForStockData(event) {
            this.selectedColumns = event.value;
        },
        async onCompanyCodeClick(inputStockData) {
            this.loading = true;

            try {
                this.activeTab = 15;
                this.selectedFormatForStockData = "Compact";
                this.selectedCustomFilterForStockData = null;

                this.specificStockData = inputStockData;
                this.specificStockDataArray = [inputStockData];

                try {
                    const [stockHistoryInfo, dividendTrapInfo] = await Promise.all([
                        StockHistoryService.getStockHistory(inputStockData.exchange, inputStockData.code),
                        StockDataService.findDividendTrapForExchange(inputStockData.exchange, 'S')
                    ]);

                    this.stockHistory = stockHistoryInfo.data;
                    this.stockHistory = stockHistoryInfo.data.filter(item => item.year >= 1999);

                    this.maxDividendYield = dividendTrapInfo.data;
                } catch (e) {
                    console.error("[Track][onCompanyCodeClick] Error fetching stock history data = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                this.onStockDataStockHistoryOptionChange();

                this.chartKey++;
                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onStockDataTimePeriodChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                }

                if (selectedOption) {
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => {
                                    const value = item[selectedOption];
                                    return (typeof value === 'number' && !isNaN(value)) ? value : null;
                                }),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false;
            }

        },
        async onStockDataStockHistoryOptionChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;
                }

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        onFormatChangeForStockData() {
            console.log("[onFormatChangeForStockData] this.selectedFormatForStockData = ", this.selectedFormatForStockData);

            this.selectedCustomFilterForStockData = null;

            if (this.selectedFormatForStockData === "Compact") {
                this.selectedColumnsForStockData = this.columnConfigBasicStockData.map(column => column.field);
            } else {
                this.selectedColumnsForStockData = this.columnConfigExtendedStockData.map(column => column.field);
            }
        },
        async onCustomFilterChangeForStockData() {

            this.loading = true;

            this.activeTab = 15;

            console.log("[onCustomFilterChangeForStockData] this.selectedCustomFilterForStockData = ", this.selectedCustomFilterForStockData);

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.selectedCustomFilterForStockData)
                ]);
                this.customFilterComponents = customFilterComponentsInfo.data;
            } catch (e) {
                console.error("[Track][onCustomFilterChangeForStockData] Error fetching filter data = ", e);
                this.loading = false;

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            let tempSelectedColumnFields = []; // Use a temporary array to build the list

            const defaultMandatoryColumnField = "codeId129";
            tempSelectedColumnFields.push(defaultMandatoryColumnField);

            console.log("[onCustomFilterChangeForStockData] tempSelectedColumnFields = ", tempSelectedColumnFields);
            console.log("[onCustomFilterChangeForStockData] this.columnConfigFullListStockData = ", this.columnConfigFullListStockData);
            console.log("[onCustomFilterChangeForStockData] this.customFilterComponents = ", this.customFilterComponents);

            this.customFilterComponents.forEach((item) => {
                console.log("[onCustomFilterChangeForStockData] customFilterComponent item.code = ", item.code);

                if (item.code && this.columnConfigFullListStockData.some(config => config.field === item.code) && !tempSelectedColumnFields.includes(item.code)) {
                    tempSelectedColumnFields.push(item.code);
                }
            });

            console.log("[onCustomFilterChangeForStockData] tempSelectedColumnFields = ", tempSelectedColumnFields);
            this.selectedColumnsForStockData = tempSelectedColumnFields;

            console.log("[onCustomFilterChangeForStockData] this.selectedColumnsForStockData = ", this.selectedColumnsForStockData);

            this.loading = false;
        },
        // onToggleColumns(value) {
        //     console.log('[TrackData][onToggleColumns] value = ', value);
        //     try {
        //         this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        //     } catch (e) {
        //         // console.error("[Track][onToggleColumns] Error on toggle columns = ", e);
        //     }
        // },
        async onCountryChange() {
            this.loading = true;
            console.log("[Achieve][onCountryChange] this.countries = ", this.countries);
            console.log("[Achieve][onCountryChange] this.selectedCountry = ", this.selectedCountry);

            try {
                const [trackDataInfo] = await Promise.all([
                    TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                ]);

                this.trackData = trackDataInfo.data;
                this.originalTrackData = trackDataInfo.data;

                if (this.selectedCountry === "ZA") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "ZA");
                } else if (this.selectedCountry === "CA") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "CA");
                } else if (this.selectedCountry === "UK") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "UK");
                } else {
                    this.trackData = this.originalTrackData.filter(track => track.country === "US");
                }

                console.log("[Achieve][onCountryChange] this.trackData = ", this.trackData);

                await this.calculateTrackSummary();

                this.columnsDefault = [
                    {header: 'Type', field: 'type', sortable: true},
                    {header: 'Country', field: 'country', sortable: true},
                    {header: 'Name', field: 'name', sortable: true},
                    {header: 'Stock Symbol', field: 'code', sortable: true},
                    {header: 'Exchange', field: 'exchange', sortable: true},
                    {header: 'Share Price', field: 'sharePriceId123'},
                    {header: 'Current Div Yld', field: 'currentDividendYieldId050'},
                    {header: 'Fwd Ann Div Income', field: 'fwdAnnDivIncome', sortable: true},
                ];

                this.columnsFullList = [
                    {header: 'Type', field: 'type', sortable: true},
                    {header: 'Country', field: 'country', sortable: true},
                    {header: 'Name', field: 'name', sortable: true},
                    {header: 'Stock Symbol', field: 'code', sortable: true},
                    {header: 'Exchange', field: 'exchange', sortable: true},
                    {header: 'Fwd Ann Div Income', field: 'fwdAnnDivIncome', sortable: true},
                    {header: 'Quantity', field: 'quantity', sortable: true},
                    {header: 'Market Value', field: 'marketValue', sortable: true},
                    {header: '% of Portfolio', field: 'portfolioShare', sortable: true},
                    {header: 'Brokerage Name', field: 'brokerageName', sortable: true},
                    {header: 'Brokerage Fee', field: 'brokerageFee', sortable: true},
                    {header: 'Annual Income', field: 'annualIncome', sortable: true},
                    {header: 'Value', field: 'value', sortable: true},
                    {header: 'Purchased', field: 'purchased', sortable: true},
                    {header: 'Sold', field: 'sold', sortable: true},
                    {header: '52wk High', field: 'hspWeek52Id001'},
                    {header: '52wk Low', field: 'lspWeek52Id002'},
                    {header: 'Altman Z-Score', field: 'altmanZscoreId003'},
                    {header: 'Annual Fwd Dividend', field: 'afdId004'},
                    {header: 'R9 - Fwd Dividend vs Prev Year', field: 'afdPreviousId005'},
                    {header: 'R6 - Avg Div Growth 5yr', field: 'adgYear5Id006'},
                    {header: 'R6 - Avg Div Growth 10yr', field: 'adgYear10Id007'},
                    {header: 'R6 - Avg Div Growth 15yr', field: 'adgYear15Id008'},
                    {header: 'R6 - Avg Div Growth 20yr', field: 'adgYear20Id009'},
                    {header: 'Avg Div Yld 5yr', field: 'adyYear5Id010'},
                    {header: 'Avg Div Yld 10yr', field: 'adyYear10Id011'},
                    {header: 'Avg Div Yld 15yr', field: 'adyYear15Id012'},
                    {header: 'Avg Div Yld 20yr', field: 'adyYear20Id013'},
                    {header: 'Avg 3yr EPS', field: 'averageEpsYear3Id014'},
                    {header: 'R5a - Avg EPS Growth 5yr', field: 'averageEpsGrowthYear5Id015'},
                    {header: 'R5a - Avg EPS Growth 10yr', field: 'averageEpsGrowthYear10Id016'},
                    {header: 'R5a - Avg EPS Growth 15yr', field: 'averageEpsGrowthYear15Id017'},
                    {header: 'R5a - Avg EPS Growth 20yr', field: 'averageEpsGrowthYear20Id018'},
                    {header: 'Avg High Div Yld 5yr', field: 'averageHdyYear5Id019'},
                    {header: 'Avg High Div Yld 10yr', field: 'averageHdyYear10Id020'},
                    {header: 'Avg High Div Yld 15yr', field: 'averageHdyYear15Id021'},
                    {header: 'Avg High Div Yld 20yr', field: 'averageHdyYear20Id022'},
                    {header: 'Avg High P/E 5yr', field: 'averageHighPeRatioYear5Id023'},
                    {header: 'Avg High P/E 10yr', field: 'averageHighPeRatioYear10Id024'},
                    {header: 'Avg High P/E 15yr', field: 'averageHighPeRatioYear15Id025'},
                    {header: 'Avg High P/E 20yr', field: 'averageHighPeRatioYear20Id026'},
                    {header: 'Avg Low Div Yld 5yr', field: 'averageLdyYear5Id027'},
                    {header: 'Avg Low Div Yld 10yr', field: 'averageLdyYear10Id028'},
                    {header: 'Avg Low Div Yld 15yr', field: 'averageLdyYear15Id029'},
                    {header: 'Avg Low Div Yld 20yr', field: 'averageLdyYear20Id030'},
                    {header: 'Avg Low P/E 5yr', field: 'averageLowPeRatioYear5Id031'},
                    {header: 'Avg Low P/E 10yr', field: 'averageLowPeRatioYear10Id032'},
                    {header: 'Avg Low P/E 15yr', field: 'averageLowPeRatioYear15Id033'},
                    {header: 'Avg Low P/E 20yr', field: 'averageLowPeRatioYear20Id034'},
                    {header: 'Avg P/E 5yr', field: 'averagePeRatioYear5Id035'},
                    {header: 'Avg P/E 10yr', field: 'averagePeRatioYear10Id036'},
                    {header: 'Avg P/E 15yr', field: 'averagePeRatioYear15Id037'},
                    {header: 'Avg P/E 20yr', field: 'averagePeRatioYear20Id038'},
                    {header: 'Bk Value/Share', field: 'bookValuePerShareId039'},
                    {header: 'Cashflow/Share', field: 'cashFlowPerShareId040'},
                    {header: 'City', field: 'companyAddressCityId041'},
                    {header: 'Country', field: 'companyAddressCountryId042'},
                    {header: 'State/Prov', field: 'companyAddressStateId043'},
                    {header: 'Address', field: 'companyAddressId044'},
                    {header: 'Description', field: 'companyDescriptionId045'},
                    {header: 'Name', field: 'companyNameId046'},
                    {header: 'Consecutive Yrs Div Increases', field: 'yearsDividendIncreasesId047'},
                    {header: 'Consecutive Yrs EPS Increases', field: 'yearsEpsIncreasesId048'},
                    {header: 'Current Assets', field: 'currentAssetsId049'},
                    {header: 'Current Div Yld', field: 'currentDividendYieldId050'},
                    {header: 'Current Debt', field: 'currentLiabilitiesId051'},
                    {header: 'Current Ratio', field: 'currentRatioId052'},
                    {header: 'DCF', field: 'dcfId061'},
                    {header: 'Div Currency', field: 'dividendCurrencyId062'},
                    {header: 'Div Frequency', field: 'dividendFrequencyId063'},
                    {header: 'EPS (TTM)', field: 'epsTtmId071'},
                    {header: 'ESG Score', field: 'esgScoreId072'},
                    {header: 'Ex-Div Date', field: 'exDividendDateId074'},
                    {header: 'Fiscal Yr End', field: 'fiscalYearendDateId075'},
                    {header: 'Graham Price', field: 'grahamPriceId076'},
                    {header: 'Industry', field: 'industryId081'},
                    {header: 'LT Debt', field: 'longtermDebtId082'},
                    {header: 'LT Debt/Total Capital', field: 'longtermDebtVsTotalCapitalId083'},
                    {header: 'R8 - LT Debt/Equity', field: 'longtermDebtEquityRatioId084'},
                    {header: 'Market/Country', field: 'marketId089'},
                    {header: 'Market Cap', field: 'marketCapitalisationId090'},
                    {header: 'Net Income', field: 'netIncomeId091'},
                    {header: 'Net Income/Share TTM', field: 'netIncomePerShareId092'},
                    {header: 'Employees', field: 'employeesId093'},
                    {header: 'Operating Cashflow', field: 'operatingCashflowId100'},
                    {header: 'P/B Ratio', field: 'pbRatioId102'},
                    {header: 'P/CF Ratio', field: 'pcfRatioId103'},
                    {header: 'P/E Ratio TTM', field: 'peRatioId104'},
                    {header: 'P/FCF Ratio', field: 'pfcfRatioId105'},
                    {header: 'P/S Ratio', field: 'psRatioId106'},
                    {header: 'Quick Ratio', field: 'quickRatioId116'},
                    {header: 'ROA TTM', field: 'roaTtmId118'},
                    {header: 'ROC TTM', field: 'rocTtmId119'},
                    {header: 'ROE TTM', field: 'roeTtmId120'},
                    {header: 'Sector', field: 'sectorId121'},
                    {header: 'Share Price', field: 'sharePriceId123'},
                    {header: 'Share Date & Time', field: 'sharePriceDateId124'},
                    {header: 'SI Criteria out of 10 (5yr Data)', field: 'siCriteriaYear5Id125'},
                    {header: 'SI Criteria out of 10 (10yr Data)', field: 'siCriteriaYear10Id126'},
                    {header: 'SI Criteria out of 10 (15yr Data)', field: 'siCriteriaYear15Id127'},
                    {header: 'SI Criteria out of 10 (20yr Data)', field: 'siCriteriaYear20Id128'},
                    {header: 'Stock Symbol', field: 'codeId129'},
                    {header: 'Total Debt/Equity Ratio', field: 'totalDebtVsEquityRatioId130'},
                    {header: 'Total Stockholder Equity', field: 'totalStockholderEquityId131'},
                    {
                        header: 'R11b - Under/Over Valued Using 5yr Data',
                        field: 'undervaluedVsOvervaluedStatusYear5Id132'
                    },
                    {
                        header: 'R11b - Under/Over Valued Using 10yr Data',
                        field: 'undervaluedVsOvervaluedStatusYear10Id133'
                    },
                    {
                        header: 'R11b - Under/Over Valued Using 15yr Data',
                        field: 'undervaluedVsOvervaluedStatusYear15Id134'
                    },
                    {
                        header: 'R11b - Under/Over Valued Using 20yr Data',
                        field: 'undervaluedVsOvervaluedStatusYear20Id135'
                    },
                    {header: 'Website', field: 'websiteId136'}
                ];


                this.columnsCompleteList = [
                    {header: 'Type', field: 'type', sortable: true},
                    {header: 'Country', field: 'country', sortable: true},
                    {header: 'Name', field: 'name', sortable: true},
                    {header: 'Stock Symbol', field: 'code', sortable: true},
                    {header: 'Exchange', field: 'exchange', sortable: true},
                    {header: 'Quantity', field: 'quantity', sortable: true},
                    {header: 'Fwd Ann Div Income', field: 'fwdAnnDivIncome', sortable: true},
                    {header: 'R5a - Avg EPS Growth 20yr', field: 'averageEpsGrowthYear20Id018'},
                    {header: 'R5b - EPS Increases in 20yrs', field: 'epsIncreasesYear20Id097'},
                    {header: 'R6 - Avg Div Growth 20yr', field: 'adgYear20Id009'},
                    {header: 'R7 - Payout Ratio', field: 'payoutRatioId107'},
                    {header: 'R8 - LT Debt/Equity', field: 'longtermDebtEquityRatioId084'},
                    {header: 'R9 - Fwd Dividend vs Prev Year', field: 'afdPreviousId005'},
                    {header: 'R10 - Share Buyback?', field: 'shareBuybackId122'},
                    {header: 'R11a - P/E Ratio TTM', field: 'peRatioId104'},
                    {header: 'R11c - P/B Ratio', field: 'pbRatioId102'},
                    {header: 'Consecutive Yrs Div Increases', field: 'yearsDividendIncreasesId047'},
                    {header: 'Share Price', field: 'sharePriceId123'},
                    {header: 'Current Div Yld', field: 'currentDividendYieldId050'},
                ];

                this.columnsCompactList = [
                    {header: 'Type', field: 'type', sortable: true},
                    {header: 'Country', field: 'country', sortable: true},
                    {header: 'Name', field: 'name', sortable: true},
                    {header: 'Stock Symbol', field: 'code', sortable: true},
                    {header: 'Exchange', field: 'exchange', sortable: true},
                    {header: 'Share Price', field: 'sharePriceId123'},
                    {header: 'Current Div Yld', field: 'currentDividendYieldId050'},
                    {header: 'Fwd Ann Div Income', field: 'fwdAnnDivIncome', sortable: true},
                ];

                this.selectedColumns = this.columnsDefault;

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onFormatChange() {
            console.log("[TrackData][onFormatChange] this.selectedFormat = ", this.selectedFormat);

            if (this.selectedFormat === "Compact") {
                this.selectedColumns = this.columnsFullList.filter(config =>
                    this.columnsCompactList.some(compact => compact.field === config.field)
                );

            } else {

                this.selectedColumns = this.columnsFullList.filter(config =>
                    this.columnsCompleteList.some(compact => compact.field === config.field)
                );

            }
        },
        async onCustomFilterChange() {
            // this.activeTab = 8;
            this.activeTab = 4;
            this.loading = true;

            console.log("[onCustomFilterChange] this.selectedCustomFilter = ", this.selectedCustomFilter);

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.selectedCustomFilter)
                ]);

                this.customFilterComponents = customFilterComponentsInfo.data;
                console.log("[Overview][onCustomFilterChange] this.customFilterComponents = ", this.customFilterComponents);

            } catch (e) {
                console.error("[Overview][onCustomFilterChange] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.customFilterStockDataList = [];

            console.log("[Track][onCustomFilterChange] this.trackData = ", this.trackData);
            console.log("[Track][onCustomFilterChange] this.columnsFullList = ", this.columnsFullList);
            console.log("[Track][onCustomFilterChange] this.selectedColumns = ", this.selectedColumns);

            this.selectedColumns = [];

            console.log("[Track][onCustomFilterChange] this.selectedColumns = ", this.selectedColumns);

            let criteriaString = "";

            const matchingColumnCode = this.columnsFullList.find(config => config.field === "code");
            this.selectedColumns = [
                ...this.selectedColumns,
                {
                    field: matchingColumnCode.field,
                    header: matchingColumnCode.header,
                    style: matchingColumnCode.style,
                    sortable: matchingColumnCode.sortable,
                    frozen: matchingColumnCode.frozen || false,
                    body: matchingColumnCode.body,
                },
            ];

            console.log("[Track][onCustomFilterChange] this.selectedColumns = ", this.selectedColumns);

            this.customFilterComponents.forEach((item) => {
                console.log("Filter Code = ", item.code);
                console.log("Filter Operator = ", item.operator);
                console.log("Filter Value = ", item.value);

                // Lookup item.code in columnConfig
                const matchingColumn = this.columnsFullList.find(config => config.field === item.code);

                if (matchingColumn) {
                    // Check if selectedColumns already contains this column
                    const alreadySelected = this.selectedColumns.some(col => col.field === matchingColumn.field);

                    if (!alreadySelected) {
                        // Add the matching column to selectedColumns
                        this.selectedColumns = [
                            ...this.selectedColumns,
                            {
                                field: matchingColumn.field,
                                header: matchingColumn.header,
                                style: matchingColumn.style,
                                sortable: matchingColumn.sortable,
                                frozen: matchingColumn.frozen || false,
                                body: matchingColumn.body,
                            },
                        ];
                    }
                } else {
                    console.warn(`No match found for item.code: ${item.code}`);
                }

                console.log("[Overview][onCustomFilterChange] this.selectedColumns = ", this.selectedColumns);
                console.log("[Overview][onCustomFilterChange] this.columnsFullList = ", this.columnsFullList);
            });

            console.log("[Overview][onCustomFilterChange] FINAL. this.selectedColumns = ", this.selectedColumns);
            console.log("[Overview][onCustomFilterChange] FINAL. this.columnsFullList = ", this.columnsFullList);

            this.customFilterComponents = this.customFilterComponents.filter(item => item.operator !== '0');

            console.log("[Overview][onCustomFilterChange] FINAL. this.customFilterComponents.length = ", this.customFilterComponents.length);

            if (this.customFilterComponents.length > 0) {
                this.customFilterComponents.forEach((item, index, array) => {
                    if (item.operator != '0') {
                        // console.log(`Iteration ${index}:`);
                        // console.log("Filter Code = ", item.code);
                        // console.log("Filter Operator = ", item.operator);
                        // console.log("Filter Value = ", item.value);

                        let operatorString = "=";
                        // let isCharacter = false;

                        switch (item.operator) {
                            case 'E':
                                operatorString = "===";
                                break;
                            case 'G':
                                operatorString = ">";
                                break;
                            case 'L':
                                operatorString = "<";
                                break;
                            case 'H':
                                operatorString = ">=";
                                break;
                            case 'M':
                                operatorString = "<=";
                                break;
                            case 'N':
                                operatorString = "!==";
                                break;
                            default:
                                operatorString = "===";
                                break;
                        }

                        let isNumeric = true;

                        if ((item.code === "companyAddressCityId041") ||
                            (item.code === "companyAddressCountryId042") ||
                            (item.code === "companyAddressStateId043") ||
                            (item.code === "companyAddressId044") ||
                            (item.code === "companyDescriptionId045") ||
                            (item.code === "companyNameId046") ||
                            (item.code === "dividendCurrencyId062") ||
                            (item.code === "dividendFrequencyId063") ||
                            (item.code === "dividendPaymentDateId068") ||
                            (item.code === "dividendRecordDateId069") ||
                            (item.code === "dividendPaidId070") ||
                            (item.code === "exchangeId073") ||
                            (item.code === "exDividendDateId074") ||
                            (item.code === "fiscalYearendDateId075") ||
                            (item.code === "industryId081") ||
                            (item.code === "marketId089") ||
                            (item.code === "sectorId121") ||
                            (item.code === "shareBuybackId122") ||
                            (item.code === "sharePriceDateId124") ||
                            (item.code === "undervaluedVsOvervaluedStatusYear5Id132") ||
                            (item.code === "undervaluedVsOvervaluedStatusYear10Id133") ||
                            (item.code === "undervaluedVsOvervaluedStatusYear15Id134") ||
                            (item.code === "undervaluedVsOvervaluedStatusYear20Id135") ||
                            (item.code === "websiteId136") ||
                            (item.code === "typeId139")) {
                            isNumeric = false;
                        }

                        // switch (item.code) {
                        //     case 'undervaluedVsOvervaluedStatusYear20Id135':
                        //         isCharacter = true;
                        //         break;
                        //     default:
                        //         isCharacter = false;
                        //         break;
                        // }

                        // Check if it's the last element
                        if (index === array.length - 1) {
                            console.log("This is the last element.");
                            if (isNumeric) {
                                criteriaString = criteriaString + "stock." + item.code + " " + operatorString + " " + item.value + " ";
                            } else {
                                criteriaString = criteriaString + "stock." + item.code + " " + operatorString + " '" + item.value + "' ";
                            }
                        } else {
                            if (isNumeric) {
                                criteriaString = criteriaString + "stock." + item.code + " " + operatorString + " " + item.value + " && ";
                            } else {
                                criteriaString = criteriaString + "stock." + item.code + " " + operatorString + " '" + item.value + "' && ";
                            }

                        }
                    }
                });


                try {
                    console.log("[Debug] criteriaString:", criteriaString);
                    const dynamicFilter = new Function('stock', `return ${criteriaString};`);
                    // this.stockData = this.originalStockData.filter(stock => dynamicFilter(stock));
                    this.trackData = this.trackData.filter(stock => dynamicFilter(stock));
                    console.log("Filtered Track Data:", this.trackData);
                } catch (e) {
                    console.error("Error in dynamic filter function:", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }
            // else {
            //     this.stockData = this.originalStockData;
            // }

            this.loading = false;
            console.log("[Overview][onCustomFilterChange] END. this.selectedColumns = ", this.selectedColumns);

        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0'); // Returns a formatted string with thousand separators
            } else {
                return '0'; // Ensure consistency by returning a string
            }
        },
        formatString(value) {
            if (value) {
                const formattedValue = String(value).substring(0, 50);
                return formattedValue;
            } else {
                return '';
            }
        },
        async calculateTrackSummary() {

            this.loading = true;

            const [trackDataInfoActual, trackDataInfoProjected] = await Promise.all([
                TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'A'),
                TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
            ]);

            this.trackDataActual = trackDataInfoActual.data;
            this.trackDataProjected = trackDataInfoProjected.data;


            this.workingTrackData = this.trackDataActual;

            if (this.userConfig.siPlanCurrency === "USD") {
                console.log("[Achieve][calculateTrackSummary] Processing USD");

                this.calculationTrackData = this.workingTrackData.filter(track => track.country === "US");

                console.log("[Achieve][calculateTrackSummary] this.calculationTrackData (US) = ", this.calculationTrackData);

                this.totalIncomeStocksActual = this.calculationTrackData
                    .filter(item => item.type === 'S')
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);

                this.totalIncomeFundsActual = this.calculationTrackData
                    .filter(item => ((item.type === 'E') || (item.type === 'F')))
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);

                this.totalIncomeBusinessesActual = this.calculationTrackData
                    .filter(item => item.type === 'I') // Filter items where type is 'S'
                    .reduce((sum, item) => sum + (item.annualIncome || 0), 0); // Sum up fwdAnnDivIncome, defaulting to 0 if undefined

                console.log("[Achieve][calculateTrackSummary] this.totalIncomeStocksActual (US) = ", this.totalIncomeStocksActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeFundsActual (US) = ", this.totalIncomeFundsActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeBusinessesActual (US) = ", this.totalIncomeBusinessesActual);


                this.calculationTrackData = this.workingTrackData.filter(track => track.country === "CA");

                console.log("[Achieve][calculateTrackSummary] this.calculationTrackData (CA) = ", this.calculationTrackData);

                this.totalIncomeStocksActual = this.totalIncomeStocksActual + (this.calculationTrackData
                    .filter(item => item.type === 'S')
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0) * 0.7174);

                this.totalIncomeFundsActual = this.totalIncomeFundsActual + (this.calculationTrackData
                    .filter(item => ((item.type === 'E') || (item.type === 'F')))
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0) * 0.7174);

                this.totalIncomeBusinessesActual = this.totalIncomeBusinessesActual + (this.calculationTrackData
                    .filter(item => item.type === 'I')
                    .reduce((sum, item) => sum + (item.annualIncome || 0), 0) * 0.7174);

                console.log("[Achieve][calculateTrackSummary] this.totalIncomeStocksActual (CA) = ", this.totalIncomeStocksActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeFundsActual (CA) = ", this.totalIncomeFundsActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeBusinessesActual (CA) = ", this.totalIncomeBusinessesActual);

            } else if (this.userConfig.siPlanCurrency === "CAD") {
                console.log("[Achieve][calculateTrackSummary] Processing CAD");

                this.calculationTrackData = this.workingTrackData.filter(track => track.country === "US");

                console.log("[Achieve][calculateTrackSummary] this.calculationTrackData (US) = ", this.calculationTrackData);

                this.totalIncomeStocksActual = this.calculationTrackData
                    .filter(item => item.type === 'S')
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0) * 1.394;

                this.totalIncomeFundsActual = this.calculationTrackData
                    .filter(item => ((item.type === 'E') || (item.type === 'F')))
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0) * 1.394;

                this.totalIncomeBusinessesActual = this.calculationTrackData
                    .filter(item => item.type === 'I') // Filter items where type is 'S'
                    .reduce((sum, item) => sum + (item.annualIncome || 0), 0) * 1.394;

                console.log("[Achieve][calculateTrackSummary] this.totalIncomeStocksActual (US) = ", this.totalIncomeStocksActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeFundsActual (US) = ", this.totalIncomeFundsActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeBusinessesActual (US) = ", this.totalIncomeBusinessesActual);

                this.calculationTrackData = this.workingTrackData.filter(track => track.country === "CA");

                console.log("[Achieve][calculateTrackSummary] this.calculationTrackData (CA) = ", this.calculationTrackData);

                this.totalIncomeStocksActual = this.totalIncomeStocksActual + (this.calculationTrackData
                    .filter(item => item.type === 'S')
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0));

                this.totalIncomeFundsActual = this.totalIncomeFundsActual + (this.calculationTrackData
                    .filter(item => ((item.type === 'E') || (item.type === 'F')))
                    .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0));

                this.totalIncomeBusinessesActual = this.totalIncomeBusinessesActual + (this.calculationTrackData
                    .filter(item => item.type === 'I') // Filter items where type is 'S'
                    .reduce((sum, item) => sum + (item.annualIncome || 0), 0));

                console.log("[Achieve][calculateTrackSummary] this.totalIncomeStocksActual (CA) = ", this.totalIncomeStocksActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeFundsActual (CA) = ", this.totalIncomeFundsActual);
                console.log("[Achieve][calculateTrackSummary] this.totalIncomeBusinessesActual (CA) = ", this.totalIncomeBusinessesActual);

            } else if (this.userConfig.siPlanCurrency === "UK") {
                console.log("[Achieve][calculateTrackSummary] Processing GBP");

            } else {
                console.log("[Achieve][calculateTrackSummary] Processing ZAR");

            }


            // this.originalTrackData = trackDataInfo.data;
            //
            // this.trackDataActual = trackDataInfo.data;
            // this.originalTrackDataActual = trackDataInfo.data;
            //
            // this.trackFundsActual = this.originalTrackDataActual
            //     .filter(item => item.type === 'F' || item.type === 'E');
            //
            // console.log("[Achieve][calculateTrackSummary] this.trackFundsActual = ", this.trackFundsActual);
            //
            // this.totalIncomeStocksActual = this.originalTrackDataActual
            //     .filter(item => item.type === 'S')
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalIncomeFundsActual = this.originalTrackDataActual
            //     .filter(item => ((item.type === 'E') || (item.type === 'F')))
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalIncomeBusinessesActual = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.annualIncome || 0), 0); // Sum up fwdAnnDivIncome, defaulting to 0 if undefined
            //
            //
            // this.totalIncomeStocksActual = this.originalTrackDataActual
            //     .filter(item => item.type === 'S')
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalIncomeFundsActual = this.originalTrackDataActual
            //     .filter(item => ((item.type === 'E') || (item.type === 'F')))
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalIncomeBusinessesActual = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.annualIncome || 0), 0); // Sum up fwdAnnDivIncome, defaulting to 0 if undefined
            //
            //
            //
            //
            // this.totalTrackFundsCurrentAnnualDivIncome = this.originalTrackDataActual
            //     .filter(item => item.type === 'F' || item.type === 'E')
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalTrackFundsMarketValue = this.originalTrackDataActual
            //     .filter(item => ((item.type === 'E') || (item.type === 'F')))
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalTrackFundsFees10yrs = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalTrackFundsFees20yrs = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalTrackFundsFees40yrs = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // this.totalTrackFundsPortfolioYield = this.originalTrackDataActual
            //     .filter(item => item.type === 'I') // Filter items where type is 'S'
            //     .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);
            //
            // const [trackDataInfoProjected] = await Promise.all([
            //     TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
            // ]);
            //
            // this.trackDataProjected = trackDataInfoProjected.data;
            // this.originalTrackDataProjected = trackDataInfoProjected.data;

            this.totalIncomeStocksProjected = this.trackDataProjected
                .filter(item => item.type === 'S')
                .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);

            this.totalIncomeFundsProjected = this.trackDataProjected
                .filter(item => ((item.type === 'E') || (item.type === 'F')))
                .reduce((sum, item) => sum + (item.fwdAnnDivIncome || 0), 0);

            this.totalIncomeBusinessesProjected = this.trackDataProjected
                .filter(item => item.type === 'I') // Filter items where type is 'S'
                .reduce((sum, item) => sum + (item.annualIncome || 0), 0); // Sum up fwdAnnDivIncome, defaulting to 0 if undefined

            this.totalAmountInvestedProjected = this.trackDataProjected
                .filter(item => ((item.type === 'S') || (item.type === 'E') || (item.type === 'F')))

                .reduce((sum, item) => {
                    // Ensure quantity and purchased are numbers, default to 0 if not present or invalid
                    const quantity = Number(item.quantity) || 0;
                    const purchased = Number(item.unitPurchasePrice) || 0;
                    return sum + (quantity * purchased);
                }, 0);

            console.log("[Achieve][calculateTrackSummary] this.totalIncomeStocksProjected = ", this.totalIncomeStocksProjected);
            console.log("[Achieve][calculateTrackSummary] this.totalIncomeFundsProjected = ", this.totalIncomeFundsProjected);
            console.log("[Achieve][calculateTrackSummary] this.totalIncomeBusinessesProjected = ", this.totalIncomeBusinessesProjected);
            console.log("[Achieve][calculateTrackSummary] this.totalAmountInvestedProjected = ", this.totalAmountInvestedProjected);

            this.loading = false;
        },
        searchCodes(event) {
            console.log("[Achieve][searchCodes] event.query = ", event.query);
            console.log("[Achieve][searchCodes] this.newTrackData.exchange = ", this.newTrackData.exchange);
            console.log("[Achieve][searchCodes] this.selectedWatchlistCode = ", this.selectedWatchlistCode);

            StockService.searchStocksForExchangeByName(this.newTrackData.exchange, event.query.toLowerCase())
                .then(data => {
                    // this.filteredCodes = data.data;
                    this.filteredCodes = data.data.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code // or the entire stock object, depending on your needs
                    }));
                    console.log("[Achieve][searchCodes] Got client data = ", data.data);
                })
                .catch(e => {
                    console.log("[Achieve][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                });
        },
        // searchCodes(event) {
        //     console.log("[TrackData][searchCodes] event.query = ", event.query);
        //
        //     StockService.searchStocksForExchangeByName(this.newTrackData.exchange, event.query.toLowerCase())
        //         .then(data => {
        //             console.log("[TrackData][searchCodes] Getting codes for exchange = ", this.newTrackData.exchange);
        //             this.filteredCodes = data.data;
        //             console.log("[TrackData][searchCodes] Got codes = ", data.data);
        //         })
        //         .catch(e => {
        //             console.log("[TrackData][searchCodes] Could not get codes for exchange = ", this.newTrackData.exchange);
        //             console.log("[TrackData][searchCodes] Error = ", e);
        //         });
        //
        // },
        async callMockPortfolio() {
            this.activeTab = 4;

            this.loading = true;
            console.log("[Achieve][callMockPortfolio] this.countries = ", this.countries);
            console.log("[Achieve][callMockPortfolio] this.selectedCountry = ", this.selectedCountry);

            try {
                const [trackDataInfo] = await Promise.all([
                    TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                ]);

                this.trackData = trackDataInfo.data;
                this.originalTrackData = trackDataInfo.data;

                console.log("[Achieve][callMockPortfolio] this.originalTrackData = ", this.originalTrackData);

                if (this.selectedCountry === "ZA") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "ZA");
                } else if (this.selectedCountry === "CA") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "CA");
                } else if (this.selectedCountry === "UK") {
                    this.trackData = this.originalTrackData.filter(track => track.country === "UK");
                } else {
                    this.trackData = this.originalTrackData.filter(track => track.country === "US");
                }

                console.log("[Achieve][callMockPortfolio] this.trackData = ", this.trackData);

                await this.calculateTrackSummary();

                this.columnsDefault = [
                    {field: 'type', header: 'Type', sortable: true, frozen: true},
                    {field: 'country', header: 'Country', sortable: true, frozen: true},
                    {field: 'name', header: 'Name', sortable: true, frozen: true},
                    {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                    {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                    {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                    {field: 'currentDividendYieldId050', header: 'Current Div Yld', sortable: true},
                    {field: 'investmentReturn', header: 'Return', sortable: true},
                    {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                ];

                this.columnsFullList = [
                    {field: 'type', header: 'Type', sortable: true, frozen: true},
                    {field: 'country', header: 'Country', sortable: true, frozen: true},
                    {field: 'name', header: 'Name', sortable: true, frozen: true},
                    {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                    {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                    {field: 'investmentReturn', header: 'Return', sortable: true},
                    {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                    {field: 'quantity', header: 'Quantity', sortable: true},
                    {field: 'unitPurchasePrice', header: 'Unit Purchase Price', sortable: true},
                    {field: 'marketValue', header: 'Market Value', sortable: true},
                    {field: 'portfolioShare', header: '% of Portfolio', sortable: true},
                    {field: 'divYieldOnCost', header: 'Div Yield On Cost', sortable: true},
                    {field: 'accountType', header: 'Account Type', sortable: true},
                    {field: 'brokerageName', header: 'Brokerage Name', sortable: true},
                    {field: 'brokerageFee', header: 'Brokerage Fee', sortable: true},
                    {field: 'annualIncome', header: 'Annual Income', sortable: true},
                    {field: 'value', header: 'Value', sortable: true},
                    {field: 'purchased', header: 'Purchased', sortable: true},
                    {field: 'sold', header: 'Sold', sortable: true},
                    {field: "hspWeek52Id001", header: "52wk High", sortable: true},
                    {field: "lspWeek52Id002", header: "52wk Low", sortable: true},
                    {field: "altmanZscoreId003", header: "Altman Z-Score", sortable: true},
                    {field: "afdId004", header: "Annual Fwd Dividend", sortable: true},
                    {field: "afdPreviousId005", header: "R9 - Fwd Dividend vs Prev Year", sortable: true},
                    {field: "adgYear5Id006", header: "R6 - Avg Div Growth 5yr", sortable: true},
                    {field: "adgYear10Id007", header: "R6 - Avg Div Growth 10yr", sortable: true},
                    {field: "adgYear15Id008", header: "R6 - Avg Div Growth 15yr", sortable: true},
                    {field: "adgYear20Id009", header: "R6 - Avg Div Growth 20yr", sortable: true},
                    {field: "adyYear5Id010", header: "Avg Div Yld 5yr", sortable: true},
                    {field: "adyYear10Id011", header: "Avg Div Yld 10yr", sortable: true},
                    {field: "adyYear15Id012", header: "Avg Div Yld 15yr", sortable: true},
                    {field: "adyYear20Id013", header: "Avg Div Yld 20yr", sortable: true},
                    {field: "averageEpsYear3Id014", header: "Avg 3yr EPS", sortable: true},
                    {field: "averageEpsGrowthYear5Id015", header: "R5a - Avg EPS Growth 5yr", sortable: true},
                    {field: "averageEpsGrowthYear10Id016", header: "R5a - Avg EPS Growth 10yr", sortable: true},
                    {field: "averageEpsGrowthYear15Id017", header: "R5a - Avg EPS Growth 15yr", sortable: true},
                    {field: "averageEpsGrowthYear20Id018", header: "R5a - Avg EPS Growth 20yr", sortable: true},
                    {field: "averageHdyYear5Id019", header: "Avg High Div Yld 5yr", sortable: true},
                    {field: "averageHdyYear10Id020", header: "Avg High Div Yld 10yr", sortable: true},
                    {field: "averageHdyYear15Id021", header: "Avg High Div Yld 15yr", sortable: true},
                    {field: "averageHdyYear20Id022", header: "Avg High Div Yld 20yr", sortable: true},
                    {field: "averageHighPeRatioYear5Id023", header: "Avg High P/E 5yr", sortable: true},
                    {field: "averageHighPeRatioYear10Id024", header: "Avg High P/E 10yr", sortable: true},
                    {field: "averageHighPeRatioYear15Id025", header: "Avg High P/E 15yr", sortable: true},
                    {field: "averageHighPeRatioYear20Id026", header: "Avg High P/E 20yr", sortable: true},
                    {field: "averageLdyYear5Id027", header: "Avg Low Div Yld 5yr", sortable: true},
                    {field: "averageLdyYear10Id028", header: "Avg Low Div Yld 10yr", sortable: true},
                    {field: "averageLdyYear15Id029", header: "Avg Low Div Yld 15yr", sortable: true},
                    {field: "averageLdyYear20Id030", header: "Avg Low Div Yld 20yr", sortable: true},
                    {field: "averageLowPeRatioYear5Id031", header: "Avg Low P/E 5yr", sortable: true},
                    {field: "averageLowPeRatioYear10Id032", header: "Avg Low P/E 10yr", sortable: true},
                    {field: "averageLowPeRatioYear15Id033", header: "Avg Low P/E 15yr", sortable: true},
                    {field: "averageLowPeRatioYear20Id034", header: "Avg Low P/E 20yr", sortable: true},
                    {field: "averagePeRatioYear5Id035", header: "Avg P/E 5yr", sortable: true},
                    {field: "averagePeRatioYear10Id036", header: "Avg P/E 10yr", sortable: true},
                    {field: "averagePeRatioYear15Id037", header: "Avg P/E 15yr", sortable: true},
                    {field: "averagePeRatioYear20Id038", header: "Avg P/E 20yr", sortable: true},
                    {field: "bookValuePerShareId039", header: "Bk Value/Share", sortable: true},
                    {field: "cashFlowPerShareId040", header: "Cashflow/Share", sortable: true},
                    {field: "companyAddressCityId041", header: "City", sortable: true},
                    {field: "companyAddressCountryId042", header: "Country", sortable: true},
                    {field: "companyAddressStateId043", header: "State/Prov", sortable: true},
                    {field: "companyAddressId044", header: "Address", sortable: true},
                    {field: "companyDescriptionId045", header: "Description", sortable: true},
                    {field: "companyNameId046", header: "Name", sortable: true},
                    {field: "yearsDividendIncreasesId047", header: "Consecutive Yrs Div Increases", sortable: true},
                    {field: "yearsEpsIncreasesId048", header: "Consecutive Yrs EPS Increases", sortable: true},
                    {field: "currentAssetsId049", header: "Current Assets", sortable: true},
                    {field: "currentDividendYieldId050", header: "Current Div Yld", sortable: true},
                    {field: "currentLiabilitiesId051", header: "Current Debt", sortable: true},
                    {field: "currentRatioId052", header: "Current Ratio", sortable: true},
                    {
                        field: "diffDyCurrentVsAverageYear5Id053",
                        header: "Diff Between Current Div Yld & Avg Div Yld 5yrs",
                        sortable: true
                    },
                    {
                        field: "diffDyCurrentVsAverageYear10Id054",
                        header: "Diff Between Current Div Yld & Avg Div Yld 10yrs",
                        sortable: true
                    },
                    {
                        field: "diffDyCurrentVsAverageYear15Id055",
                        header: "Diff Between Current Div Yld & Avg Div Yld 15yrs",
                        sortable: true
                    },
                    {
                        field: "diffDyCurrentVsAverageYear20Id056",
                        header: "Diff Between Current Div Yld & Avg Div Yld 20yrs",
                        sortable: true
                    },
                    {
                        field: "diffPeCurrentVsAverageYear5Id057",
                        header: "Diff Between Current P/E & Avg P/E 5yrs",
                        sortable: true
                    },
                    {
                        field: "diffPeCurrentVsAverageYear10Id058",
                        header: "Diff Between Current P/E & Avg P/E 10yrs",
                        sortable: true
                    },
                    {
                        field: "diffPeCurrentVsAverageYear15Id059",
                        header: "Diff Between Current P/E & Avg P/E 15yrs",
                        sortable: true
                    },
                    {
                        field: "diffPeCurrentVsAverageYear20Id060",
                        header: "Diff Between Current P/E & Avg P/E 20yrs",
                        sortable: true
                    },
                    {field: "dcfId061", header: "DCF", sortable: true},
                    {field: "dividendCurrencyId062", header: "Div Currency", sortable: true},
                    {field: "dividendFrequencyId063", header: "Div Frequency", sortable: true},
                    {field: "dgPlusDyYear5Id064", header: "Div Gr (5yr) + Curr Div Yld", sortable: true},
                    {field: "dgPlusDyYear10Id065", header: "Div Gr (10yr) + Curr Div Yld", sortable: true},
                    {field: "dgPlusDyYear15Id066", header: "Div Gr (15yr) + Curr Div Yld", sortable: true},
                    {field: "dgPlusDyYear20Id067", header: "Div Gr (20yr) + Curr Div Yld", sortable: true},
                    {field: "dividendPaymentDateId068", header: "Div Payment Date", sortable: true},
                    {field: "dividendRecordDateId069", header: "Div Record Date", sortable: true},
                    {field: "dividendPaidId070", header: "Divs Paid Since", sortable: true},
                    {field: "epsTtmId071", header: "EPS (TTM)", sortable: true},
                    {field: "esgScoreId072", header: "ESG Score", sortable: true},
                    {field: "exDividendDateId074", header: "Ex-Div Date", sortable: true},
                    {field: "fiscalYearendDateId075", header: "Fiscal Yr End", sortable: true},
                    {field: "grahamPriceId076", header: "Graham Price", sortable: true},
                    {field: "hspYear5Id077", header: "High Price Using 5yr Data", sortable: true},
                    {field: "hspYear10Id078", header: "High Price Using 10yr Data", sortable: true},
                    {field: "hspYear15Id079", header: "High Price Using 15yr Data", sortable: true},
                    {field: "hspYear20Id080", header: "High Price Using 20yr Data", sortable: true},
                    {field: "industryId081", header: "Industry", sortable: true},
                    {field: "longtermDebtId082", header: "LT Debt", sortable: true},
                    {field: "longtermDebtVsTotalCapitalId083", header: "LT Debt/Total Capital", sortable: true},
                    {field: "longtermDebtEquityRatioId084", header: "R8 - LT Debt/Equity", sortable: true},
                    {field: "lspYear5Id085", header: "Low Price Using 5yr Data", sortable: true},
                    {field: "lspYear10Id086", header: "Low Price Using 10yr Data", sortable: true},
                    {field: "lspYear15Id087", header: "Low Price Using 15yr Data", sortable: true},
                    {field: "lspYear20Id088", header: "Low Price Using 20yr Data", sortable: true},
                    {field: 'marketId089', header: 'Market/Country', sortable: true},
                    {field: 'marketCapitalisationId090', header: 'Market Cap', sortable: true},
                    {field: 'netIncomeId091', header: 'Net Income', sortable: true},
                    {field: 'netIncomePerShareId092', header: 'Net Income/Share TTM', sortable: true},
                    {field: 'employeesId093', header: 'Employees', sortable: true},
                    {field: 'epsIncreasesYear5Id094', header: 'R5b - EPS Increases in 5yrs', sortable: true},
                    {field: 'epsIncreasesYear10Id095', header: 'R5b - EPS Increases in 10yrs', sortable: true},
                    {field: 'epsIncreasesYear15Id096', header: 'R5b - EPS Increases in 15yrs', sortable: true},
                    {field: 'epsIncreasesYear20Id097', header: 'R5b - EPS Increases in 20yrs', sortable: true},
                    {field: 'outstandingSharesCurrentYearId098', header: 'Share Outstanding', sortable: true},
                    {
                        field: 'outstandingSharesPreviousYearId099',
                        header: 'Share Outstanding (previous Yr)',
                        sortable: true
                    },
                    {field: 'operatingCashflowId100', header: 'Operating Cashflow', sortable: true},
                    {field: 'operatingCashflowRatioId101', header: 'Operating Cashflow Ratio', sortable: true},
                    {field: 'pbRatioId102', header: 'R11c - P/B Ratio', sortable: true},
                    {field: 'pcfRatioId103', header: 'P/CF Ratio', sortable: true},
                    {field: 'peRatioId104', header: 'R11a - P/E Ratio TTM', sortable: true},
                    {field: 'pfcfRatioId105', header: 'P/FCF Ratio', sortable: true},
                    {field: 'psRatioId106', header: 'P/S Ratio', sortable: true},
                    {field: 'payoutRatioId107', header: 'R7 - Payout Ratio', sortable: true},
                    {field: 'pegRatioYear5Id108', header: 'PEG Ratio Using Avg EPS Growth 5yr', sortable: true},
                    {field: 'pegRatioYear10Id109', header: 'PEG Ratio Using Avg EPS Growth 10yr', sortable: true},
                    {field: 'pegRatioYear15Id110', header: 'PEG Ratio Using Avg EPS Growth 15yr', sortable: true},
                    {field: 'pegRatioYear20Id111', header: 'PEG Ratio Using Avg EPS Growth 20yr', sortable: true},
                    {
                        field: 'diffGrahamPriceSharePriceId112',
                        header: '% diff Graham Price vs Share Price',
                        sortable: true
                    },
                    {field: 'sharesOwnedInstitutionsId113', header: '% Owned by Institutions', sortable: true},
                    {field: 'piotroskiFscoreId114', header: 'Piotroski F-Score', sortable: true},
                    {field: 'profitMarginId115', header: 'Total Operating Profit Margin', sortable: true},
                    {field: 'quickRatioId116', header: 'Quick Ratio', sortable: true},
                    {field: 'recentDividendPaymentId117', header: 'Recent Div Payment', sortable: true},
                    {field: 'roaTtmId118', header: 'ROA TTM', sortable: true},
                    {field: 'rocTtmId119', header: 'ROC TTM', sortable: true},
                    {field: 'roeTtmId120', header: 'ROE TTM', sortable: true},
                    {field: 'sectorId121', header: 'Sector', sortable: true},
                    {field: 'shareBuybackId122', header: 'R10 - Share Buyback?', sortable: true},
                    {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                    {field: 'sharePriceDateId124', header: 'Share Date & Time', sortable: true},
                    {field: 'siCriteriaYear5Id125', header: 'SI Criteria out of 10 (5yr Data)', sortable: true},
                    {field: 'siCriteriaYear10Id126', header: 'SI Criteria out of 10 (10yr Data)', sortable: true},
                    {field: 'siCriteriaYear15Id127', header: 'SI Criteria out of 10 (15yr Data)', sortable: true},
                    {field: 'siCriteriaYear20Id128', header: 'SI Criteria out of 10 (20yr Data)', sortable: true},
                    {field: 'codeId129', header: 'Stock Symbol', sortable: true},
                    {field: 'totalDebtVsEquityRatioId130', header: 'Total Debt/Equity Ratio', sortable: true},
                    {field: 'totalStockholderEquityId131', header: 'Total Stockholder Equity', sortable: true},
                    {
                        field: 'undervaluedVsOvervaluedStatusYear5Id132',
                        header: 'R11b - Under/Over Valued Using 5yr Data',
                        sortable: true
                    },
                    {
                        field: 'undervaluedVsOvervaluedStatusYear10Id133',
                        header: 'R11b - Under/Over Valued Using 10yr Data',
                        sortable: true
                    },
                    {
                        field: 'undervaluedVsOvervaluedStatusYear15Id134',
                        header: 'R11b - Under/Over Valued Using 15yr Data',
                        sortable: true
                    },
                    {
                        field: 'undervaluedVsOvervaluedStatusYear20Id135',
                        header: 'R11b - Under/Over Valued Using 20yr Data',
                        sortable: true
                    },
                    {field: 'websiteId136', header: 'Website', sortable: true}
                ]

                this.columnsCompactList = [
                    {field: 'type', header: 'Type', sortable: true, frozen: true},
                    {field: 'country', header: 'Country', sortable: true, frozen: true},
                    {field: 'name', header: 'Name', sortable: true, frozen: true},
                    {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                    {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                    {field: 'sharePriceId123', header: 'Share Price', sortable: true},
                    {field: 'currentDividendYieldId050', header: 'Current Div Yld', sortable: true},
                    {field: 'investmentReturn', header: 'Return', sortable: true},
                    {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                ];

                this.columnsCompleteList = [
                    {field: 'type', header: 'Type', sortable: true, frozen: true},
                    {field: 'country', header: 'Country', sortable: true, frozen: true},
                    {field: 'name', header: 'Name', sortable: true, frozen: true},
                    {field: 'code', header: 'Stock Symbol', sortable: true, frozen: true},
                    {field: 'exchange', header: 'Exchange', sortable: true, frozen: true},
                    {field: 'sharePriceId123', header: 'Share Price'},
                    {field: 'currentDividendYieldId050', header: 'Current Div Yld'},
                    {field: 'investmentReturn', header: 'Return', sortable: true},
                    {field: 'fwdAnnDivIncome', header: 'Fwd Ann Div Income', sortable: true},
                    {field: 'quantity', header: 'Quantity', sortable: true},
                    {field: 'averageEpsGrowthYear20Id018', header: 'R5a - Avg EPS Growth 20yr', sortable: true},
                    {field: 'epsIncreasesYear20Id097', header: 'R5b - EPS Increases in 20yrs', sortable: true},
                    {field: 'adgYear20Id009', header: 'R6 - Avg Div Growth 20yr', sortable: true},
                    {field: 'payoutRatioId107', header: 'R7 - Payout Ratio', sortable: true},
                    {field: 'longtermDebtEquityRatioId084', header: 'R8 - LT Debt/Equity', sortable: true},
                    {field: 'afdPreviousId005', header: 'R9 - Fwd Dividend vs Prev Year', sortable: true},
                    {field: 'shareBuybackId122', header: 'R10 - Share Buyback?', sortable: true},
                    {field: 'peRatioId104', header: 'R11a - P/E Ratio TTM', sortable: true},
                    {field: 'pbRatioId102', header: 'R11c - P/B Ratio', sortable: true},
                    {field: 'yearsDividendIncreasesId047', header: 'Consecutive Yrs Div Increases', sortable: true}
                ]

                this.selectedColumns = this.columnsDefault;

                console.log("[Achieve][callMockPortfolio] this.selectedColumns = ", this.selectedColumns);

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }

        },
        async callFeesTable() {
            this.activeTab = 11;

            const [trackDataFeesInfo] = await Promise.all([
                TrackDataService.getTrackDataFeesForUser(this.userStore.user.id)
            ]);

            this.trackDataFees = trackDataFeesInfo.data;

            console.log("[Achieve][callFeesTable] this.trackDataFees = ", this.trackDataFees);

        },
        async callPortfolioGrowthSimulator() {
            this.activeTab = 10;
            // this.achieveConfiguration.startingBalance = 1000;
            // this.achieveConfiguration.additionalInvestment = 500;
            // this.achieveConfiguration.useInflation = 'N';
            // this.achieveConfiguration.usePersonalHistory = 'N';
            // this.achieveConfiguration.useLivingExpenses = 'N';
            // this.achieveConfiguration.dividendYield = 4.5;
            // this.achieveConfiguration.shareGrowth = 5.5;
            // this.achieveConfiguration.expensesAccommodation = 0;
            // this.achieveConfiguration.expensesTravel = 0;
            // this.achieveConfiguration.expensesGroceries = 0;
            // this.achieveConfiguration.expensesEntertainment = 0;
            // this.achieveConfiguration.expensesMiscellaneous = 0;

            await this.calculateTable();
        },
        async callPortfolioGrowthSimulatorDashboard() {
            this.activeTab = 10;
            await this.calculateTable();
        },
        callPortfolioGrowthSimulatorSettings() {
            this.activeTab = 12;

            // this.achieveConfiguration.startingBalance = 1000;
            // this.achieveConfiguration.additionalInvestment = 500;
            // this.achieveConfiguration.useInflation = 'N';
            // this.achieveConfiguration.usePersonalHistory = 'N';
            // this.achieveConfiguration.useLivingExpenses = 'N';
            // this.achieveConfiguration.useReducedLivingExpenses = 'N';
            // this.achieveConfiguration.dividendYield = 4.5;
            // this.achieveConfiguration.shareGrowth = 5.5;
            // this.achieveConfiguration.expensesAccommodation = 0;
            // this.achieveConfiguration.expensesTravel = 0;
            // this.achieveConfiguration.expensesGroceries = 0;
            // this.achieveConfiguration.expensesEntertainment = 0;
            // this.achieveConfiguration.expensesMiscellaneous = 0;
            //
            // this.calculateTable();
        },
        callBackToSummary() {
            this.activeTab = 3;
        },
        callAddTrackDataStock() {
            console.log('[TrackData][callAddTrackDataStock] Start.');

            this.newTrackData = {};
            this.newTrackData.country = "US";
            this.newTrackData.exchange = "NYSE";
            this.newTrackData.purchasedDate = moment().toDate();
            this.newTrackData.purchasedDate.setMinutes(0);

            this.activeTab = 5;
        },
        callAddTrackDataOther() {
            console.log('[TrackData][callAddTrackDataOther] Start.');

            this.newTrackData = {};
            this.newTrackData.country = "US";
            this.newTrackData.purchasedDate = moment().toDate();
            this.newTrackData.purchasedDate.setMinutes(0);

            this.activeTab = 8;
        },
        callUpdateTrackData(trackDataItem) {
            this.existingTrackData = trackDataItem;

            if (this.existingTrackData.type === 'I') {
                this.activeTab = 9;
            } else {
                this.activeTab = 6;
            }
        },
        callDeleteTrackData(trackDataItem) {
            this.existingTrackData = trackDataItem;
            this.confirmationResponse = 'N';
            this.activeTab = 7;
        },
        async processSupport() {
            this.submitted = true;

            if (this.supportData.description) {

                try {
                    this.newTask = {
                        type: 'S',
                        severity: 'N',
                        category: 'F',
                        priority: 1,
                        max: 259200,
                        clientVisible: 'N',
                        due: moment().add(5, 'days').startOf('hour').toDate()
                    };

                    console.log("[Overview][processSupport] this.client.id = ", this.client.id);

                    var newTaskDto = {
                        companyId: this.profile.companyId,
                        requesterId: this.userStore.user.id,
                        clientId: this.client.id,
                        description: 'Achieve Page :: ' + this.supportData.type + ' :: ' + this.supportData.description,
                        max: this.newTask.max,
                        type: this.newTask.type,
                        severity: this.newTask.severity,
                        category: this.newTask.category,
                        priority: this.newTask.priority,
                        note: this.supportData.note,
                        clientVisible: this.newTask.clientVisible,
                        due: moment(this.newTask.due).format('YYYY-MM-DD HH:mm'),
                    };

                    console.log("[Overview][processSupport] Created task. Data = ", newTaskDto);

                    const response = await TaskService.createTask(this.profile.companyId, newTaskDto);
                    console.log('[Overview][processSupport] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created support request',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][processSupport] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create support request. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 14;
            this.submitted = false;
        },
        async addTrackDataStock() {
            this.submitted = true;

            console.log('[Achieve][addTrackDataStock] this.newTrackData = ', this.newTrackData);
            console.log('[Achieve][addTrackDataStock] this.newTrackData.stock = ', this.newTrackData.stock);
            console.log('[Achieve][addTrackDataStock] this.newTrackData.stock.value = ', this.newTrackData.stock.value);

            if (this.newTrackData.quantity) {

                try {

                    var newTrackDataDto = {
                        userId: this.userStore.user.id,
                        code: this.newTrackData.stock.value,
                        exchange: this.newTrackData.exchange,
                        quantity: this.newTrackData.quantity,
                        category: 'P',
                        type: 'S',
                        status: 'A'
                    };

                    console.log('[Track][addTrackDataStock] newTrackDataDto = ', newTrackDataDto);

                    const response = await TrackDataService.createTrackData(this.userStore.user.id, newTrackDataDto);
                    console.log('[Track][addTrackDataStock] Response = ', response);

                    const [trackDataInfo] = await Promise.all([
                        TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                    ]);

                    this.trackData = trackDataInfo.data;
                    this.originalTrackData = trackDataInfo.data;

                    if (this.selectedCountry === "ZA") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "ZA");
                    } else if (this.selectedCountry === "CA") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "CA");
                    } else if (this.selectedCountry === "UK") {
                        this.trackData = this.originalTrackData.filter(track => track.country === "UK");
                    } else {
                        this.trackData = this.originalTrackData.filter(track => track.country === "US");
                    }

                    // this.restoreToOriginal();
                    await this.calculateTrackSummary();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added info',
                        life: 3000
                    });

                    this.submitted = false;

                } catch (e) {
                    console.error('[Track][addTrackData] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add info. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.newTrackData = {};
            this.activeTab = 4;
            this.submitted = false;

        },
        async addTrackDataOther() {
            this.submitted = true;

            console.log('[Track][addTrackDataOther] this.newTrackData = ', this.newTrackData);

            if (this.newTrackData.name) {

                try {

                    var newTrackDataDto = {
                        userId: this.userStore.user.id,
                        country: this.newTrackData.country,
                        name: this.newTrackData.name,
                        annualIncome: this.newTrackData.annualIncome,
                        value: this.newTrackData.value,
                        purchased: moment(this.newTrackData.purchased).format('YYYY-MM-DD'),
                        category: 'P',
                        type: 'I',
                        status: 'A'
                    };

                    console.log('[Track][addTrackDataStock] newTrackDataDto = ', newTrackDataDto);

                    const response = await TrackDataService.createTrackData(this.userStore.user.id, newTrackDataDto);
                    console.log('[Track][addTrackDataStock] Response = ', response);

                    const [trackDataInfo] = await Promise.all([
                        TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                    ]);

                    this.trackData = trackDataInfo.data;
                    this.originalTrackData = trackDataInfo.data;

                    // this.restoreToOriginal();
                    await this.calculateTrackSummary();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added info',
                        life: 3000
                    });
                } catch (e) {
                    console.error('[Track][addTrackData] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add info. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.newTrackData = {};
            this.activeTab = 4;
            this.submitted = false;

        },
        async updateTrackData() {
            this.submitted = true;

            console.log('[Track][updateTrackData] this.existingTrackData = ', this.existingTrackData);

            if (this.existingTrackData.accountType) {

                try {

                    var newTrackDataDto = {
                        userId: this.existingTrackData.userId,
                        country: this.existingTrackData.country,
                        name: this.existingTrackData.name,
                        uniqueId: this.existingTrackData.uniqueId,
                        annualIncome: this.existingTrackData.annualIncome,
                        value: this.existingTrackData.value,
                        accountType: this.existingTrackData.accountType,
                        code: this.existingTrackData.code,
                        exchange: this.existingTrackData.exchange,
                        quantity: this.existingTrackData.quantity,
                        unitPurchasePrice: this.existingTrackData.unitPurchasePrice,
                        brokerageName: this.existingTrackData.brokerageName,
                        brokerageFee: this.existingTrackData.brokerageFee,
                        purchased: moment(this.existingTrackData.purchased).format('YYYY-MM-DD'),
                        category: this.existingTrackData.category,
                        type: this.existingTrackData.type,
                        status: this.existingTrackData.status
                    };

                    console.log('[Track][updateTrackData] newTrackDataDto = ', newTrackDataDto);

                    const response = await TrackDataService.updateTrackData(this.existingTrackData.id, newTrackDataDto);
                    console.log('[Track][updateTrackData] Response = ', response);

                    // const [trackDataInfo] = await Promise.all([
                    //     TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                    // ]);
                    //
                    // this.trackData = trackDataInfo.data;
                    // this.originalTrackData = trackDataInfo.data;

                    await this.calculateTrackSummary();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated info',
                        life: 3000
                    });
                } catch (e) {
                    console.error('[Track][updateTrackData] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update info. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.existingTrackData = {};
            this.activeTab = 4;
            this.submitted = false;

        },
        async deleteTrackData() {
            this.submitted = true;

            console.log('[Track][deleteTrackData] this.existingTrackData = ', this.existingTrackData);

            if (this.confirmationResponse.trim() === "Y") {

                if (this.existingTrackData.id) {

                    try {
                        const response = await TrackDataService.deleteTrackData(this.existingTrackData.id);
                        console.log('[Track][deleteTrackData] Response = ', response);

                        // const [trackDataInfo] = await Promise.all([
                        //     TrackDataService.getTrackDataForUserAndCategory(this.userStore.user.id, 'P')
                        // ]);
                        //
                        // this.trackData = trackDataInfo.data;
                        // this.originalTrackData = trackDataInfo.data;

                        await this.calculateTrackSummary();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted info',
                            life: 3000
                        });
                    } catch (e) {
                        console.error('[Track][deleteTrackData] Error:', e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete info. Please try again.',
                            life: 3000
                        });

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }
                }

                this.activeTab = 4;
                this.submitted = false;

            }

        },
        async saveAchieveInfo() {

            try {
                var newDataDto = {
                    siSimulatorStartingBalance: this.achieveConfiguration.startingBalance,
                    siSimulatorAdditionalInvestment: this.achieveConfiguration.additionalInvestment,
                    siSimulatorDividendYield: this.achieveConfiguration.dividendYield,
                    siSimulatorShareGrowth: this.achieveConfiguration.shareGrowth,
                    siSimulatorCompareExpenses: this.achieveConfiguration.useLivingExpenses,
                    siSimulatorExpensesAccommodation: this.achieveConfiguration.expensesAccommodation,
                    siSimulatorExpensesTravel: this.achieveConfiguration.expensesTravel,
                    siSimulatorExpensesGroceries: this.achieveConfiguration.expensesGroceries,
                    siSimulatorExpensesEntertainment: this.achieveConfiguration.expensesEntertainment,
                    siSimulatorExpensesMiscellaneous: this.achieveConfiguration.expensesMiscellaneous
                };

                console.log('[Achieve][saveAchieveInfo] this.userStore.user.id = ', this.userStore.user.id);
                console.log('[Achieve][saveAchieveInfo] newDataDto = ', newDataDto);

                const response = await UserService.updateUserConfig(this.userStore.user.id, newDataDto);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfig = userConfigData.data;
                    console.log("[Achieve][saveAchieveInfo] this.userConfig = ", this.userConfig);

                    this.achieveConfiguration.startingBalance = this.userConfig.siSimulatorStartingBalance;
                    this.achieveConfiguration.additionalInvestment = this.userConfig.siSimulatorAdditionalInvestment;
                    this.achieveConfiguration.useLivingExpenses = this.userConfig.siSimulatorCompareExpenses;
                    this.achieveConfiguration.dividendYield = this.userConfig.siSimulatorDividendYield;
                    this.achieveConfiguration.shareGrowth = this.userConfig.siSimulatorShareGrowth;
                    this.achieveConfiguration.expensesAccommodation = this.userConfig.siSimulatorExpensesAccommodation;
                    this.achieveConfiguration.expensesTravel = this.userConfig.siSimulatorExpensesTravel;
                    this.achieveConfiguration.expensesGroceries = this.userConfig.siSimulatorExpensesGroceries;
                    this.achieveConfiguration.expensesEntertainment = this.userConfig.siSimulatorExpensesEntertainment;
                    this.achieveConfiguration.expensesMiscellaneous = this.userConfig.siSimulatorExpensesMiscellaneous;

                } catch (e) {
                    console.error("[Achieve][saveAchieveInfo] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                console.log('[Achieve][saveAchieveInfo] Response = ', response);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated simulator information',
                    life: 3000
                });

            } catch (e) {
                console.error('[Achieve][saveAchieveInfo] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update simulator information. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            await this.calculateTable();

            this.activeTab = 10;

        },
        calculateTable() {

            const years = 50; // You can change this to however many years you need
            // let balance = this.startingBalance;
            let balance = parseFloat(this.achieveConfiguration.startingBalance);
            let dividendYield = parseFloat(this.achieveConfiguration.dividendYield);
            let stockGrowth = parseFloat(this.achieveConfiguration.shareGrowth);
            let additionalInvestment = parseFloat(this.achieveConfiguration.additionalInvestment);
            let livingExpenses = parseFloat(this.achieveConfiguration.expensesAccommodation) + parseFloat(this.achieveConfiguration.expensesTravel)
                + parseFloat(this.achieveConfiguration.expensesGroceries) + parseFloat(this.achieveConfiguration.expensesEntertainment)
                + parseFloat(this.achieveConfiguration.expensesMiscellaneous);
            let table = [];

            console.log("[SiAchieve][calculateTable] balance = ", balance);
            console.log("[SiAchieve][calculateTable] additionalInvestment = ", additionalInvestment);
            console.log("[SiAchieve][calculateTable] dividendYield = ", dividendYield);
            console.log("[SiAchieve][calculateTable] stockGrowth = ", stockGrowth);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.inflationRate = ", this.achieveConfiguration.inflationRate);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.expensesAccommodation = ", this.achieveConfiguration.expensesAccommodation);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.expensesTravel = ", this.achieveConfiguration.expensesTravel);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.expensesGroceries = ", this.achieveConfiguration.expensesGroceries);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.expensesEntertainment = ", this.achieveConfiguration.expensesEntertainment);
            console.log("[SiAchieve][calculateTable] this.achieveConfiguration.expensesMiscellaneous = ", this.achieveConfiguration.expensesMiscellaneous);
            console.log("[SiAchieve][calculateTable] livingExpenses = ", livingExpenses);

            const previousYear = new Date().getFullYear() - 1;
            console.log("[SiAchieve][calculateTable] previousYear = ", previousYear);

            for (let i = 1; i <= years; i++) {
                let dividendsEarned = balance * (dividendYield / 100);
                let endingStockValue = (balance + additionalInvestment) * (1 + stockGrowth / 100);
                let endingBalance = endingStockValue + dividendsEarned;

                // let endingAdditionalInvestment = additionalInvestment + (additionalInvestment * ((parseFloat(this.achieveConfiguration.inflationRate) * (i - 1)) / 100.0));
                let endingAdditionalInvestment = additionalInvestment;

                // let endingLivingExpenses = livingExpenses + (livingExpenses * ((parseFloat(this.achieveConfiguration.inflationRate) * (i - 1)) / 100.0));
                let endingLivingExpenses = livingExpenses;

                // if (i === 1) {
                //     endingAdditionalInvestment = additionalInvestment;
                // }


                console.log("[SiAchieve][calculateTable] dividendsEarned = ", dividendsEarned);
                console.log("[SiAchieve][calculateTable] endingStockValue = ", endingStockValue);
                console.log("[SiAchieve][calculateTable] endingBalance = ", endingBalance);
                console.log("[SiAchieve][calculateTable] endingAdditionalInvestment = ", endingAdditionalInvestment);
                console.log("[SiAchieve][calculateTable] endingLivingExpenses = ", endingLivingExpenses);

                table.push({
                    yearNumber: i,
                    year: previousYear + i,
                    startingBalance: balance,
                    additionalInvestment: endingAdditionalInvestment,
                    dividendsEarned: dividendsEarned,
                    endingStockValue: endingStockValue,
                    endingBalance: endingBalance,
                    livingExpenses: endingLivingExpenses
                });

                balance = endingBalance;
            }

            this.investmentTable = table;
            this.onTableUpdated();
        },
        onTableUpdated() {
            // Additional logic or explicit refresh
            console.log("Investment table updated", this.investmentTable);
            // You can add more logic here if needed
        },
    }
}
</script>

<style scoped>
:deep(.custom-center-header .p-column-header-content) {
    justify-content: center !important;
}

.p-multiselect-panel .p-multiselect-items {
    scroll-behavior: auto !important;
}

a {
    text-decoration: none;
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-A {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-S {
        background: #ecd1be;
        color: #256029;
    }

    &.status-F {
        background: #FEEDAF;
        color: #8A5340;
    }


    &.status-I {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-E {
        background: #FFCDD2;
        color: #C63737;
    }

}
</style>
